import React, { useEffect, useState } from 'react';
import {
	makeStyles,
	Button,
	Box,
	InputAdornment,
	Tabs,
	Tab,
	withStyles,
	FormControlLabel,
	Checkbox,
	Divider,
	Grid,
	MenuItem,
	Radio,
	TextField as TextField2,
} from '@material-ui/core';
import TitleText from '../components/reusableComponents/TitleText';
import { Field, Form, Formik, FieldArray } from 'formik';
import DatePicker from '@mui/lab/DatePicker';
import { TextField } from 'formik-material-ui';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import {
	setMealInfo,
	setPayment,
	togglePGModal,
	togglePriceChangeModal,
	toggleSessionExpiredModal,
} from '../reducers/UiReducer';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import seat from '../assets/images/seat.png';
import meal from '../assets/images/meal.png';
import {
	FlightBookEtravDispatch,
	FlightBookDispatch,
	FlightTicketLCCDispatch,
	FlightAddBookingDispatch,
	FlightTicketLCCDispatchReturn,
	FlightTicketLCC1WDispatch,
} from '../reducers/HomeReducer';
import paymenthandle from './HandelPayment';
import { walletBalanceAgentDispatch } from '../reducers/UserReducer';
import ErrorModal from '../components/reusableComponents/ErrorModal';
import etravBooking from './EtravBookingForm';
import tbobooking from './TBOBookingLCCForm';
import tbobookingnonlcc from './TBOBookingNonLCC';
import addBooking from './FormAddBooking';
import { flightDebitAmount } from '../reducers/HomeReducer';
import {
	FlightFareQuoteDispatch,
	FlightFareQuoteEtravDispatch,
} from '../reducers/HomeReducer';
import BookingAlreadyPNRModal from '../components/reusableComponents/BookingAlreadyPNRModal';
import Seat from '../components/reusableComponents/Seat';
import WorldlinePG from '../components/reusableComponents/WorldlinePG';
import addBookingReturn from './FormAddBookingReturn';
import addINtBooking from './FormIntAddBooking';
import { setBaggage } from '../reducers/UiReducer';
import { FlightBookTripJackDispatch } from '../reducers/TripjackReducer';
import addBookingReturnEtrav from './FormAddBookingReturnEtrav';
const title = ['Mr', 'Mrs', 'Ms', 'Mstr', 'Miss'];
const titleC = ['Mstr', 'Miss'];
const titleI = ['Mr', 'Ms', 'Mstr', 'Miss'];
const useStyles = makeStyles((theme) => ({
	selectField: {
		'& .MuiOutlinedInput-root': {
			'& fieldset': {
				border: '1px solid #959595',
			},
		},
		backgroundColor: 'white',
		marginBottom: 30,
		width: '100%',
		marginTop: 10,
		borderRadius: 5,
		[theme.breakpoints.down('xs')]: {
			marginBottom: 15,
			marginTop: 8,
		},
		'& .MuiOutlinedInput-root': {
			borderRadius: 5,
		},
		'& .css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root': {
			borderRadius: 5,
		},
	},
	InputPropsStyle: {
		backgroundColor: 'white',
		borderRadius: 5,
	},
	inputPropsStyle: {
		padding: 14,
	},
	createButton: {
		backgroundColor: 'rgb(239, 51, 57)',
		color: 'white',
		borderRadius: 5,
		width: '100%',
		padding: '11px 8px',
		'&:hover': {
			backgroundColor: 'rgb(239, 51, 57)',
		},
	},
	tabBorder: {
		borderBottom: '2px solid transparent',
		color: '#7B95AB',
		fontWeight: 400,
	},
	tabBorderColor: {
		borderBottom: '2px solid #313131',
		color: '#00325B',
		fontWeight: 700,
	},
	tab: {
		[theme.breakpoints.up('sm')]: {
			'& .MuiTab-root': {
				minWidth: 241,
				fontSize: 22,
			},
		},
	},
	date: {
		'& .MuiOutlinedInput-root': {
			borderRadius: 5,
			width: '100%',
		},
	},
	dob: {
		'& .MuiFormControl-root': {
			width: '100%',
		},
	},
	passport: {
		'& .MuiFormControl-root': {
			width: '100%',
		},
	},
	root: {
		'& .MuiFormHelperText-root': {
			fontSize: 12,
		},
		'& .MuiOutlinedInput-input': {
			fontSize: 14,
			padding: '13px 14px',
		},
		'& MuiInputLabel-root': {
			fontSize: 16,
		},
		'& label': {
			fontSize: 15,
		},
	},
	scroll: {
		'&::-webkit-scrollbar': { width: '20px' },
	},
	root2: {
		'& .MuiOutlinedInput-input': {
			fontSize: 14,
			padding: '13px 14px',
		},
		'& MuiInputLabel-root': {
			fontSize: 16,
		},
		'& label': {
			fontSize: 15,
		},
	},
}));
const FlightConfirmForm = ({ value }) => {
	const classes = useStyles();
	const location = useLocation();
	const history = useHistory();
	const dispatch = useDispatch();
	const [state, setState] = React.useState({});
	const [state2, setState2] = React.useState({});
	const [mealprice, setMealr] = useState(0);
	const [hold, setHold] = useState(false);
	const [meal1, setMeal1] = useState('');
	const [child1, setChild1] = React.useState(location.state.child1);
	const [child2, setChild2] = React.useState(location.state.child2);
	const [child3, setChild3] = React.useState(location.state.child3);
	const [child4, setChild4] = React.useState(location.state.child4);
	const [child5, setChild5] = React.useState(location.state.child4);
	const [child6, setChild6] = React.useState(location.state.child4);
	const [infant1, setInfant1] = React.useState(location.state.infant1);
	const [infant2, setInfant2] = React.useState(location.state.infant2);
	const [infant3, setInfant3] = React.useState(location.state.infant3);
	const [infant4, setInfant4] = React.useState(location.state.infant4);
	const [infant5, setInfant5] = React.useState(location.state.infant5);
	const [infant6, setInfant6] = React.useState(location.state.infant6);
	const [age, setAge] = React.useState('');
	const [meal, setMeal] = React.useState('');

	const handleChange = (event) => {
		setAge(event.target.value);
	};
	const handleChangeMeal = (event) => {
		setMeal(event.target.value);
	};
	const {
		selectedOrigin,
		selectedDepart,
		baggageAdult1,
		baggageAdult2,
		baggageAdult3,
		baggageAdult4,
		baggageAdult5,
		baggageAdult6,
		baggageAdult7,
		baggageAdult8,
		baggageAdult9,
		baggageChild1,
		baggageChild2,
		baggageChild3,
		baggageChild4,
		baggageChild5,
		baggageChild6,

		mealAdult1,
		mealAdult2,
		mealAdult3,
		mealAdult4,
		mealAdult5,
		mealAdult6,
		mealAdult7,
		mealAdult8,
		mealAdult9,
		mealChild1,
		mealChild2,
		mealChild3,
		mealChild4,
		mealChild5,
		mealChild6,
	} = useSelector((state) => state.ui);
	const [pay, setPay] = useState(false);
	const { agentlogin, travellerlogin } = useSelector((state) => state.user);
	const { farequotetripjack } = useSelector((state) => state.tripjack);
	const [addon, setAddon] = useState(0);
	const {
		payment,
		etravflightFare,
		baggageInfo,
		mealInfo,
		curr,
		priceChange,
		priceSection,
	} = useSelector((state) => state.ui);
	const { ssrTBO, loading, currency } = useSelector((state) => state.home);
	const { walletagent } = useSelector((state) => state.user);
	// const Convert = Number(curr==='INR'?currency.conversion_rates.INR:curr==='USD'?currency.conversion_rates.USD:curr==='AFN'?currency.conversion_rates.AFN:1)
	const { fareQuoteEtrav, fareQuote, fareQuoteReturn, onewayflightdata } =
		useSelector((state) => state.home);
	const date = new Date();
	let etrav2 = location.state.selectedonward
		? location.state.selectedonward[0].Airline_Code &&
		  location.state.selectedReturn[0].Airline_Code
		: '';
	let etrvotbor = location.state.selectedonward
		? location.state.selectedonward[0].Airline_Code &&
		  location.state.selectedReturn[0].AirlineCode
		: '';
	let etravrtboo = location.state.selectedonward
		? location.state.selectedReturn[0].Airline_Code &&
		  location.state.selectedonward[0].AirlineCode
		: '';
	let tbo2 = location.state.selectedonward
		? location.state.selectedonward[0].AirlineCode &&
		  location.state.selectedReturn[0].AirlineCode
		: '';
	const getActualFormat = (given: number) => {
		if (given < 10) {
			return 0 + '' + given.toString();
		} else {
			return given;
		}
	};
	useEffect(() => {
		if (location.state.OneflightData) {
			if (location.state.OneflightData.Airline_Code) {
				let formEtravFare = {
					Search_Key: location.state.IDEtrav,
					AirRepriceRequests: [
						{
							Flight_Key: location.state.OneflightData.Flight_Key,
							Fare_Id: location.state.OneflightData.Fares.Fare_Id,
						},
					],
					Customer_Mobile: location.state.formData.phone,
					GST_Input: false,
					SinglePricing: true,
					agent_id:
						agentlogin && agentlogin.status === 200
							? agentlogin.result.result.id
							: 0,
				};

				dispatch(FlightFareQuoteEtravDispatch(formEtravFare));
				dispatch(
					walletBalanceAgentDispatch(
						agentlogin &&
							agentlogin.result &&
							agentlogin.result.result &&
							agentlogin.result.result.email,
						agentlogin &&
							agentlogin.result &&
							agentlogin.result.result &&
							agentlogin.result.result.id
					)
				);
			} else if (location.state.OneflightData.AirlineCode) {
				let formData1 = {
					TraceId: location.state.IDTBO,
					ResultIndex: location.state.OneflightData.ResultIndex,
					agent_id:
						agentlogin && agentlogin.status === 200
							? agentlogin.result.result.id
							: 0,
				};
				let ssr = {
					TraceId: location.state.IDTBO,
					ResultIndex: location.state.OneflightData.ResultIndex,
				};

				dispatch(FlightFareQuoteDispatch(formData1, ssr, dispatch));
			}
		}
	}, []);
	if (loading) {
		console.log('loading.........');
	} else {
		if (location.state.OneflightData) {
			if (fareQuoteEtrav?.result || fareQuote?.result) {
				if (fareQuoteEtrav?.result) {
					if (
						fareQuoteEtrav?.result?.AirRepriceResponses[0].Flight.Fares
							.Total_Amount > location.state.OneflightData?.Fares?.Total_Amount
					) {
						if (priceSection) {
							dispatch(togglePriceChangeModal(true));
						}
					} else {
						console.log('first');
					}
				}
				if (fareQuote?.result) {
					if (
						fareQuote?.result.Response.Results.Fare.Total_Amount >
						location.state.OneflightData?.Fare?.Total_Amount
					) {
						if (priceSection) {
							dispatch(togglePriceChangeModal(true));
						}
					} else {
						console.log('first');
					}
				}
			}
		} else if (location.state.selectedReturn) {
			if (tbo2) {
				if (
					Number(
						Number(fareQuote?.result.Response.Results.Fare.Total_Amount) +
							Number(fareQuoteReturn?.result.Response.Results.Fare.Total_Amount)
					) >
					Number(
						Number(location.state.selectedonward[0].Fare.Total_Amount) +
							Number(location.state.selectedReturn[0].Fare.Total_Amount)
					)
				) {
					if (priceSection) {
						dispatch(togglePriceChangeModal(true));
					}
				}
			} else if (etrav2) {
				if (
					Number(
						Number(
							fareQuoteEtrav?.result?.AirRepriceResponses[0].Flight.Fares
								.Total_Amount
						) +
							Number(
								fareQuoteEtrav?.result?.AirRepriceResponses[0].Flight.Fares
									.Total_Amount
							)
					) >
					Number(
						Number(location.state.selectedonward[0].Fares.Total_Amount) +
							Number(location.state.selectedReturn[0].Fares.Total_Amount)
					)
				) {
					if (priceSection) {
						dispatch(togglePriceChangeModal(true));
					}
				}
			} else if (etrvotbor) {
				console.log('EtravTbo');
			} else if (etravrtboo) {
				console.log('tboEtrav');
			}
		} else {
			dispatch(toggleSessionExpiredModal(true));
			// window.alert('Session Expired')
		}
	}
	// console.log("first",fareQuoteEtrav?fareQuoteEtrav?.result?.AirRepriceResponses[0].Flight.Fares
	// .Total_Amount:fareQuote?.result.Response.Results.Fare.Total_Amount>location.state.OneflightData?.Fares?location.state.OneflightData?.Fares
	//     ?.Total_Amount:location.state.OneflightData?.Fare
	//     ?.Total_Amount)
	// const handleMeal = (value,index) => {
	//   setMeal(mealprice + value);
	//   setMeal1(1);
	// };
	let BookingFormData = [];
	if (location.state.formData.adult?.length > 0) {
		location.state.formData.adult.map((item) => {
			BookingFormData.push({
				...item,
				PaxType: 1,
			});
		});
	}
	if (location.state.formData.child?.length > 0) {
		location.state.formData.child.map((item) => {
			BookingFormData.push({
				...item,
				PaxType: 2,
			});
		});
	}
	if (location.state.formData.infant?.length > 0) {
		location.state.formData.infant.map((item) => {
			BookingFormData.push({
				...item,
				PaxType: 3,
			});
		});
	}
	console.log('BookingFormData', BookingFormData);

	console.log('meal', mealprice);
	const invoice = [
		date.getFullYear(),
		getActualFormat(date.getMonth() + 1),
		getActualFormat(date.getDate()),
		getActualFormat(date.getHours()),
		getActualFormat(date.getMinutes()),
		getActualFormat(date.getSeconds()),
	].join('');
	const [offline, setOffline] = useState(false);
	const [payworldline, setPayWorldline] = useState(false);
	let agentInfo = {
		email:
			agentlogin && agentlogin.status === 200
				? agentlogin.result.result.email
				: '',
		id:
			agentlogin && agentlogin.status === 200
				? agentlogin.result.result.id
				: '',
	};
	console.log('state', state);
	console.log('state2', state2);

	const handlePayment = (response) => {
		dispatch(togglePGModal(false));
		if (location.state.OneflightData?.Airline_Code) {
			etravBooking(
				location,
				response,
				invoice,
				dispatch,
				agentInfo,
				fareQuoteEtrav,
				payment,
				FlightBookEtravDispatch,
				history,
				FlightTicketLCCDispatch,
				FlightBookDispatch,
				agentlogin,
				BookingFormData,
				flightDebitAmount
			);
		} else if (location.state.OneflightData?.IsLCC) {
			tbobooking(
				location,
				response,
				invoice,
				dispatch,
				agentInfo,
				fareQuote,
				payment,
				FlightBookEtravDispatch,
				history,
				FlightTicketLCC1WDispatch,
				FlightBookDispatch,
				agentlogin,
				BookingFormData,
				baggageInfo,
				mealInfo,
				flightDebitAmount
			);
		} else if (location.state.OneflightData?.IsLCC === false) {
			tbobookingnonlcc(
				location,
				response,
				invoice,
				dispatch,
				agentInfo,
				fareQuote,
				payment,
				FlightBookEtravDispatch,
				history,
				FlightTicketLCCDispatch,
				FlightBookDispatch,
				BookingFormData,
				flightDebitAmount
			);
		} else if (location.state.OneflightData?.Supplier === 'TJK') {
			let formDataTJK = {
				bookingId: farequotetripjack.result.bookingId,
				paymentInfos: [
					{
						amount:
							Number(
								farequotetripjack.result.totalPriceInfo.totalFareDetail.fC.TF
							) +
							Number(baggageAdult1 ? baggageAdult1.amount : 0) +
							Number(baggageAdult2 ? baggageAdult2.amount : 0) +
							Number(baggageAdult3 ? baggageAdult3.amount : 0) +
							Number(baggageAdult4 ? baggageAdult4.amount : 0) +
							Number(baggageAdult5 ? baggageAdult5.amount : 0) +
							Number(baggageAdult6 ? baggageAdult6.amount : 0) +
							Number(baggageAdult7 ? baggageAdult7.amount : 0) +
							Number(baggageAdult8 ? baggageAdult8.amount : 0) +
							Number(baggageAdult9 ? baggageAdult9.amount : 0) +
							Number(baggageChild1 ? baggageChild1.amount : 0) +
							Number(baggageChild2 ? baggageChild2.amount : 0) +
							Number(baggageChild3 ? baggageChild3.amount : 0) +
							Number(baggageChild4 ? baggageChild4.amount : 0) +
							Number(baggageChild5 ? baggageChild5.amount : 0) +
							Number(baggageChild6 ? baggageChild6.amount : 0) +
							Number(mealAdult1 ? mealAdult1.amount : 0) +
							Number(mealAdult2 ? mealAdult2.amount : 0) +
							Number(mealAdult3 ? mealAdult3.amount : 0) +
							Number(mealAdult4 ? mealAdult4.amount : 0) +
							Number(mealAdult5 ? mealAdult5.amount : 0) +
							Number(mealAdult6 ? mealAdult6.amount : 0) +
							Number(mealAdult7 ? mealAdult7.amount : 0) +
							Number(mealAdult8 ? mealAdult8.amount : 0) +
							Number(mealAdult9 ? mealAdult9.amount : 0) +
							Number(mealChild1 ? mealChild1.amount : 0) +
							Number(mealChild2 ? mealChild2.amount : 0) +
							Number(mealChild3 ? mealChild3.amount : 0) +
							Number(mealChild4 ? mealChild4.amount : 0) +
							Number(mealChild5 ? mealChild5.amount : 0) +
							Number(mealChild6 ? mealChild6.amount : 0),
					},
				],
				travellerInfo: BookingFormData.map((item, index) => {
					return {
						ti: item.title,
						fN: item.firstname,
						lN: item.lastname,
						pt:
							item.PaxType == 1
								? 'ADULT'
								: item.PaxType == 2
								? 'CHILD'
								: item.PaxType == 3
								? 'INFANT'
								: '',
						dob: item.dob ? item.dob : '1996-04-09',
						pNat: 'IN',
						pid: '2021-09-08',
						pNum: item.passportnumber ? item.passportnumber : null,
						eD: item.expiry ? item.expiry : null,
						ssrBaggageInfos: item.baggage
							? [
									{
										key: item.baggage?.amount,
										code: item.baggage?.code,
									},
							  ]
							: [],
						ssrMealInfos: item.meal
							? [
									{
										key: item.meal?.amount,
										code: item.meal?.code,
									},
							  ]
							: [],
					};
				}),
				gstInfo: {
					gstNumber: '18AABCU9603R1ZM',
					email: 'apitest2ER@apitest.com ',
					registeredName: 'XYZ Pvt Ltd',
					mobile: '+918890005606',
					address: 'Dhanbad',
				},
				deliveryInfo: {
					emails: [location.state.formData.email],
					contacts: [location.state.formData.phone],
				},
			};
			dispatch(FlightBookTripJackDispatch(formDataTJK, history));
		}
		if (location.state.selectedonward) {
			if (etrav2) {
				if (payment === 'offline') {
					let debit = {
						orderId: location.state.orderID,
						paymentId:
							payment === 'offline' ? invoice : response.razorpay_payment_id,
					};
					dispatch(flightDebitAmount(debit));
				}
				let formEtrav = {
					Customer_Mobile: location.state.formData.phone,
					Passenger_Mobile: location.state.formData.phone,
					orderId: location.state.orderID,
					paymentId:
						payment === 'offline' ? invoice : response.razorpay_payment_id,
					WhatsAPP_Mobile: null,
					Passenger_Email: location.state.formData
						? location.state.formData.email
						: '',
					PAX_Details: BookingFormData.map((item, index) => {
						return {
							Pax_Id: index + 1,
							Pax_type: item.PaxType - 1,
							Title: item.title,
							First_Name: item.firstname,
							Last_Name: item.lastname,
							Gender: 0,
							Age: null,
							DOB: item.dob ? item.dob : '1998-03-09',
							Passport_Number: item.passportnumber ? item.passportnumber : null,
							Passport_Issuing_Country: null,
							Passport_Expiry: item.expiry ? item.expiry : null,
							Nationality: null,
							FrequentFlyerDetails: null,
						};
					}),

					GST: true,
					GST_Number: '',
					GST_HolderName: 'GST Holder Name',
					GST_Address: 'GST Address',
					BookingFlightDetails: fareQuoteEtrav.result.AirRepriceResponses.map(
						(item) => {
							return {
								Search_Key: location.state.IDEtrav,
								Flight_Key: item.Flight.Flight_Key,
								BookingSSRDetails: [],
							};
						}
					),
					CostCenterId: 0,
					ProjectId: 0,
					BookingRemark: `${location.state.returnBody.Segments[0].Origin}-${location.state.returnBody.Segments[0].Destination} ${location.state.returnBody.Segments[0].PreferredDepartureTime} ${invoice}`,
					CorporateStatus: 0,
					CorporatePaymentMode: 0,
					MissedSavingReason: null,
					CorpTripType: null,
					CorpTripSubType: null,
					TripRequestId: null,
					BookingAlertIds: null,
				};
				// console.log("first",formEtrav)
				dispatch(
					FlightBookEtravDispatch(
						formEtrav,
						history,
						payment,
						location.state,
						agentlogin
					)
				);
			} else if (tbo2) {
				if (payment === 'offline') {
					let debit = {
						orderId: location.state.orderID,
						paymentId:
							payment === 'offline' ? invoice : response.razorpay_payment_id,
					};
					dispatch(flightDebitAmount(debit));
				}
				if (location.state.selectedonward[0]?.IsLCC) {
					let formDataLCC = {
						orderId: location.state.orderID,
						paymentId:
							payment === 'offline' ? invoice : response.razorpay_payment_id,

						TraceId: location.state.IDTBO,
						ResultIndex: location.state.selectedonward[0].ResultIndex,

						Passengers: BookingFormData.map((item) => {
							return {
								Title: item.title,
								FirstName: item.firstname,
								LastName: item.lastname,
								PaxType: item.PaxType,
								DateOfBirth: item.dob ? item.dob : '1998-03-09',
								Gender: 1,
								PassportNo: item.passportnumber ? item.passportnumber : '',
								PassportExpiry: item.expiry ? item.expiry : '',
								AddressLine1: 'hello',
								AddressLine2: '',
								Fare: {
									Currency: location.state.selectedonward[0]
										? location.state.selectedonward[0].Fare.Currency
										: '',
									BaseFare: location.state.selectedonward[0]
										? location.state.selectedonward[0].Fare.OfferedFare
										: '',
									Tax: location.state.selectedonward[0]
										? location.state.selectedonward[0].Fare.Tax
										: '',
									YQTax: location.state.selectedonward[0]
										? location.state.selectedonward[0].Fare.YQTax
										: '',
									AdditionalTxnFeePub: location.state.selectedonward[0]
										? location.state.selectedonward[0].Fare.AdditionalTxnFeePub
										: '',
									AdditionalTxnFeeOfrd: location.state.selectedonward[0]
										? location.state.selectedonward[0].Fare.AdditionalTxnFeeOfrd
										: '',
									OtherCharges: location.state.selectedonward[0]
										? location.state.selectedonward[0].Fare.OtherCharges
										: '',
									Discount: location.state.selectedonward[0]
										? location.state.selectedonward[0].Fare.Discount
										: '',
									PublishedFare: location.state.selectedonward[0]
										? location.state.selectedonward[0].Fare.PublishedFare
										: '',
									OfferedFare: location.state.selectedonward[0]
										? location.state.selectedonward[0].Fare.OfferedFare
										: '',
									TdsOnCommission: location.state.selectedonward[0]
										? location.state.selectedonward[0].Fare.TdsOnCommission
										: '',
									TdsOnPLB: location.state.selectedonward[0]
										? location.state.selectedonward[0].Fare.TdsOnPLB
										: '',
									TdsOnIncentive: location.state.selectedonward[0]
										? location.state.selectedonward[0].Fare.TdsOnIncentive
										: '',
									ServiceFee: location.state.selectedonward[0]
										? location.state.selectedonward[0].Fare.ServiceFee
										: '',
								},
								City: 'demo',
								CountryCode: 'IN',
								CellCountryCode: '+91',
								ContactNo: location.state.formData
									? location.state.formData.phone
									: '',
								Nationality: 'IN',
								Email: location.state.formData
									? location.state.formData.email
									: '',
								IsLeadPax: true,
								FFAirlineCode: null,
								FFNumber: '',
								GSTCompanyAddress: '',
								GSTCompanyContactNumber: '',
								GSTCompanyName: '',
								GSTNumber: '',
								GSTCompanyEmail: '',
							};
						}),
						Baggage: [],
						MealDynamic: [],
						SeatDynamic: [],
					};
					console.log('FormData', formDataLCC);
					dispatch(
						FlightTicketLCCDispatch(
							formDataLCC,
							history,
							location.state,
							agentlogin
						)
					);
				} else if (location.state.selectedonward[0]?.IsLCC === false) {
					let formData = {
						TraceId: location.state.IDTBO,
						ResultIndex: location.state.selectedonward[0].ResultIndex,
						orderId: location.state.orderID,
						paymentId:
							response === 'success' ? invoice : response.razorpay_payment_id,
						Passengers: BookingFormData.map((item) => {
							return {
								Title: item.title,
								FirstName: item.firstname,
								LastName: item.lastname,
								PaxType: item.PaxType,
								DateOfBirth: item.dob ? item.dob : '1998-03-09',
								Gender: 1,
								PassportNo: item.passportnumber ? item.passportnumber : '',
								PassportExpiry: item.expiry ? item.expiry : '',
								AddressLine1: 'demoaddress',
								AddressLine2: '',
								Fare: {
									Currency: location.state.selectedonward[0]
										? location.state.selectedonward[0].Fare.Currency
										: '',
									BaseFare: location.state.selectedonward[0]
										? location.state.selectedonward[0].Fare.OfferedFare
										: '',
									Tax: location.state.selectedonward[0]
										? location.state.selectedonward[0].Fare.Tax
										: '',
									YQTax: location.state.selectedonward[0]
										? location.state.selectedonward[0].Fare.YQTax
										: '',
									AdditionalTxnFeePub: location.state.selectedonward[0]
										? location.state.selectedonward[0].Fare.AdditionalTxnFeePub
										: '',
									AdditionalTxnFeeOfrd: location.state.selectedonward[0]
										? location.state.selectedonward[0].Fare.AdditionalTxnFeeOfrd
										: '',
									OtherCharges: location.state.selectedonward[0]
										? location.state.selectedonward[0].Fare.OtherCharges
										: '',
									Discount: location.state.selectedonward[0]
										? location.state.selectedonward[0].Fare.Discount
										: '',
									PublishedFare: location.state.selectedonward[0]
										? location.state.selectedonward[0].Fare.PublishedFare
										: '',
									OfferedFare: location.state.selectedonward[0]
										? location.state.selectedonward[0].Fare.OfferedFare
										: '',
									TdsOnCommission: location.state.selectedonward[0]
										? location.state.selectedonward[0].Fare.TdsOnCommission
										: '',
									TdsOnPLB: location.state.selectedonward[0]
										? location.state.selectedonward[0].Fare.TdsOnPLB
										: '',
									TdsOnIncentive: location.state.selectedonward[0]
										? location.state.selectedonward[0].Fare.TdsOnIncentive
										: '',
									ServiceFee: location.state.selectedonward[0]
										? location.state.selectedonward[0].Fare.ServiceFee
										: '',
								},
								City: 'demo',
								CountryCode: 'IN',
								CellCountryCode: '+91',
								ContactNo: location.state.formData
									? location.state.formData.phone
									: '',
								Nationality: 'IN',
								Email: location.state.formData
									? location.state.formData.email
									: '',
								IsLeadPax: true,
								FFAirlineCode: null,
								FFNumber: '',
								GSTCompanyAddress: '',
								GSTCompanyContactNumber: '',
								GSTCompanyName: '',
								GSTNumber: '',
								GSTCompanyEmail: '',
							};
						}),
						Baggage: [],
						MealDynamic: [],
						SeatDynamic: [],
					};
					dispatch(
						FlightBookDispatch(
							formData,
							history,
							location.state.IDTBO,
							location
						)
					);
				}
				if (location.state.selectedReturn[0]?.IsLCC) {
					let formDataLCC = {
						TraceId: location.state.IDTBO,
						ResultIndex: location.state.selectedReturn[0].ResultIndex,
						orderId: location.state.orderID,
						paymentId:
							response === 'success' ? invoice : response.razorpay_payment_id,
						Passengers: BookingFormData.map((item) => {
							return {
								Title: item.title,
								FirstName: item.firstname,
								LastName: item.lastname,
								PaxType: item.PaxType,
								DateOfBirth: item.dob ? item.dob : '1998-03-09',
								Gender: 1,
								PassportNo: item.passportnumber ? item.passportnumber : '',
								PassportExpiry: item.expiry ? item.expiry : '',
								AddressLine1: 'demoaddress',
								AddressLine2: '',
								Fare: {
									Currency: location.state.selectedReturn[0]
										? location.state.selectedReturn[0].Fare.Currency
										: '',
									BaseFare: location.state.selectedReturn[0]
										? location.state.selectedReturn[0].Fare.OfferedFare
										: '',
									Tax: location.state.selectedReturn[0]
										? location.state.selectedReturn[0].Fare.Tax
										: '',
									YQTax: location.state.selectedReturn[0]
										? location.state.selectedReturn[0].Fare.YQTax
										: '',
									AdditionalTxnFeePub: location.state.selectedReturn[0]
										? location.state.selectedReturn[0].Fare.AdditionalTxnFeePub
										: '',
									AdditionalTxnFeeOfrd: location.state.selectedReturn[0]
										? location.state.selectedReturn[0].Fare.AdditionalTxnFeeOfrd
										: '',
									OtherCharges: location.state.selectedReturn[0]
										? location.state.selectedReturn[0].Fare.OtherCharges
										: '',
									Discount: location.state.selectedReturn[0]
										? location.state.selectedReturn[0].Fare.Discount
										: '',
									PublishedFare: location.state.selectedReturn[0]
										? location.state.selectedReturn[0].Fare.PublishedFare
										: '',
									OfferedFare: location.state.selectedReturn[0]
										? location.state.selectedReturn[0].Fare.OfferedFare
										: '',
									TdsOnCommission: location.state.selectedReturn[0]
										? location.state.selectedReturn[0].Fare.TdsOnCommission
										: '',
									TdsOnPLB: location.state.selectedReturn[0]
										? location.state.selectedReturn[0].Fare.TdsOnPLB
										: '',
									TdsOnIncentive: location.state.selectedReturn[0]
										? location.state.selectedReturn[0].Fare.TdsOnIncentive
										: '',
									ServiceFee: location.state.selectedReturn[0]
										? location.state.selectedReturn[0].Fare.ServiceFee
										: '',
								},
								City: 'demo',
								CountryCode: 'IN',
								CellCountryCode: '+91',
								ContactNo: location.state.formData
									? location.state.formData.phone
									: '',
								Nationality: 'IN',
								Email: location.state.formData
									? location.state.formData.email
									: '',
								IsLeadPax: true,
								FFAirlineCode: null,
								FFNumber: '',
								GSTCompanyAddress: '',
								GSTCompanyContactNumber: '',
								GSTCompanyName: '',
								GSTNumber: '',
								GSTCompanyEmail: '',
							};
						}),
						Baggage: [],
						MealDynamic: [],
						SeatDynamic: [],
					};
					console.log('FormData', formDataLCC);
					dispatch(
						FlightTicketLCCDispatchReturn(
							formDataLCC,
							history,
							location.state,
							agentlogin
						)
					);
				} else if (location.state.selectedReturn[0]?.IsLCC === false) {
					let formData = {
						TraceId: location.state.IDTBO,
						ResultIndex: location.state.selectedReturn[0].ResultIndex,
						orderId: location.state.orderID,
						paymentId:
							response === 'success' ? invoice : response.razorpay_payment_id,
						Passengers: BookingFormData.map((item) => {
							return {
								Title: item.title,
								FirstName: item.firstname,
								LastName: item.lastname,
								PaxType: item.PaxType,
								DateOfBirth: item.dob ? item.dob : '1998-03-09',
								Gender: 1,
								PassportNo: item.passportnumber ? item.passportnumber : '',
								PassportExpiry: item.expiry ? item.expiry : '',
								AddressLine1: 'demoaddress',
								AddressLine2: '',
								Fare: {
									Currency: location.state.selectedReturn[0]
										? location.state.selectedReturn[0].Fare.Currency
										: '',
									BaseFare: location.state.selectedReturn[0]
										? location.state.selectedReturn[0].Fare.OfferedFare
										: '',
									Tax: location.state.selectedReturn[0]
										? location.state.selectedReturn[0].Fare.Tax
										: '',
									YQTax: location.state.selectedReturn[0]
										? location.state.selectedReturn[0].Fare.YQTax
										: '',
									AdditionalTxnFeePub: location.state.selectedReturn[0]
										? location.state.selectedReturn[0].Fare.AdditionalTxnFeePub
										: '',
									AdditionalTxnFeeOfrd: location.state.selectedReturn[0]
										? location.state.selectedReturn[0].Fare.AdditionalTxnFeeOfrd
										: '',
									OtherCharges: location.state.selectedReturn[0]
										? location.state.selectedReturn[0].Fare.OtherCharges
										: '',
									Discount: location.state.selectedReturn[0]
										? location.state.selectedReturn[0].Fare.Discount
										: '',
									PublishedFare: location.state.selectedReturn[0]
										? location.state.selectedReturn[0].Fare.PublishedFare
										: '',
									OfferedFare: location.state.selectedReturn[0]
										? location.state.selectedReturn[0].Fare.OfferedFare
										: '',
									TdsOnCommission: location.state.selectedReturn[0]
										? location.state.selectedReturn[0].Fare.TdsOnCommission
										: '',
									TdsOnPLB: location.state.selectedReturn[0]
										? location.state.selectedReturn[0].Fare.TdsOnPLB
										: '',
									TdsOnIncentive: location.state.selectedReturn[0]
										? location.state.selectedReturn[0].Fare.TdsOnIncentive
										: '',
									ServiceFee: location.state.selectedReturn[0]
										? location.state.selectedReturn[0].Fare.ServiceFee
										: '',
								},
								City: 'demo',
								CountryCode: 'IN',
								CellCountryCode: '+91',
								ContactNo: location.state.formData
									? location.state.formData.phone
									: '',
								Nationality: 'IN',
								Email: location.state.formData
									? location.state.formData.email
									: '',
								IsLeadPax: true,
								FFAirlineCode: null,
								FFNumber: '',
								GSTCompanyAddress: '',
								GSTCompanyContactNumber: '',
								GSTCompanyName: '',
								GSTNumber: '',
								GSTCompanyEmail: '',
							};
						}),
						Baggage: [],
						MealDynamic: [],
						SeatDynamic: [],
					};
					dispatch(
						FlightBookDispatch(
							formData,
							history,
							location.state.IDTBO,
							location
						)
					);
				}
			} else if (etrvotbor) {
				if (payment === 'offline') {
					let debit = {
						orderId: location.state.orderID,
						paymentId:
							payment === 'offline' ? invoice : response.razorpay_payment_id,
					};
					dispatch(flightDebitAmount(debit));
				}
				if (location.state.selectedonward[0]?.Airline_Code) {
					let formEtrav = {
						Customer_Mobile: location.state.formData.phone,
						Passenger_Mobile: location.state.formData.phone,
						orderId: location.state.orderID,
						paymentId:
							payment === 'offline' ? invoice : response.razorpay_payment_id,
						WhatsAPP_Mobile: null,
						Passenger_Email: location.state.formData
							? location.state.formData.email
							: '',
						PAX_Details: BookingFormData.map((item, index) => {
							return {
								Pax_Id: index + 1,
								Pax_type: item.PaxType - 1,
								Title: item.title,
								First_Name: item.firstname,
								Last_Name: item.lastname,
								Gender: 0,
								Age: null,
								DOB: item.dob ? item.dob : '1998-03-09',
								Passport_Number: item.passportnumber
									? item.passportnumber
									: null,
								Passport_Issuing_Country: null,
								Passport_Expiry: item.expiry ? item.expiry : null,
								Nationality: null,
								FrequentFlyerDetails: null,
							};
						}),

						GST: true,
						GST_Number: '',
						GST_HolderName: 'GST Holder Name',
						GST_Address: 'GST Address',
						BookingFlightDetails: fareQuoteEtrav.result.AirRepriceResponses.map(
							(item) => {
								return {
									Search_Key: location.state.IDEtrav,
									Flight_Key: item.Flight.Flight_Key,
									BookingSSRDetails: [],
								};
							}
						),
						CostCenterId: 0,
						ProjectId: 0,
						BookingRemark: `${location.state.returnBody.Segments[0].Origin}-${location.state.returnBody.Segments[0].Destination} ${location.state.returnBody.Segments[0].PreferredDepartureTime} ${invoice}`,
						CorporateStatus: 0,
						CorporatePaymentMode: 0,
						MissedSavingReason: null,
						CorpTripType: null,
						CorpTripSubType: null,
						TripRequestId: null,
						BookingAlertIds: null,
					};
					// console.log("first",formEtrav)
					dispatch(
						FlightBookEtravDispatch(
							formEtrav,
							history,
							payment,
							location.state,
							agentlogin
						)
					);
				}
				if (location.state.selectedReturn[0]?.AirlineCode) {
					if (location.state.selectedReturn[0].IsLCC) {
						console.log('LCC');
						let formDataLCC = {
							TraceId: location.state.IDTBO,
							ResultIndex: location.state.selectedReturn[0].ResultIndex,
							orderId: location.state.orderID,
							paymentId:
								payment === 'offline' ? invoice : response.razorpay_payment_id,
							Passengers: BookingFormData.map((item) => {
								return {
									Title: item.title,
									FirstName: item.firstname,
									LastName: item.lastname,
									PaxType: item.PaxType,
									DateOfBirth: item.dob ? item.dob : '1998-03-09',
									Gender: 1,
									PassportNo: item.passportnumber ? item.passportnumber : '',
									PassportExpiry: item.expiry ? item.expiry : '',
									AddressLine1: 'demoaddress',
									AddressLine2: '',
									Fare: {
										Currency: location.state.selectedReturn[0]
											? location.state.selectedReturn[0].Fare.Currency
											: '',
										BaseFare: location.state.selectedReturn[0]
											? location.state.selectedReturn[0].Fare.OfferedFare
											: '',
										Tax: location.state.selectedReturn[0]
											? location.state.selectedReturn[0].Fare.Tax
											: '',
										YQTax: location.state.selectedReturn[0]
											? location.state.selectedReturn[0].Fare.YQTax
											: '',
										AdditionalTxnFeePub: location.state.selectedReturn[0]
											? location.state.selectedReturn[0].Fare
													.AdditionalTxnFeePub
											: '',
										AdditionalTxnFeeOfrd: location.state.selectedReturn[0]
											? location.state.selectedReturn[0].Fare
													.AdditionalTxnFeeOfrd
											: '',
										OtherCharges: location.state.selectedReturn[0]
											? location.state.selectedReturn[0].Fare.OtherCharges
											: '',
										Discount: location.state.selectedReturn[0]
											? location.state.selectedReturn[0].Fare.Discount
											: '',
										PublishedFare: location.state.selectedReturn[0]
											? location.state.selectedReturn[0].Fare.PublishedFare
											: '',
										OfferedFare: location.state.selectedReturn[0]
											? location.state.selectedReturn[0].Fare.OfferedFare
											: '',
										TdsOnCommission: location.state.selectedReturn[0]
											? location.state.selectedReturn[0].Fare.TdsOnCommission
											: '',
										TdsOnPLB: location.state.selectedReturn[0]
											? location.state.selectedReturn[0].Fare.TdsOnPLB
											: '',
										TdsOnIncentive: location.state.selectedReturn[0]
											? location.state.selectedReturn[0].Fare.TdsOnIncentive
											: '',
										ServiceFee: location.state.selectedReturn[0]
											? location.state.selectedReturn[0].Fare.ServiceFee
											: '',
									},
									City: '',
									CountryCode: 'IN',
									CellCountryCode: '+91',
									ContactNo: location.state.formData
										? location.state.formData.phone
										: '',
									Nationality: 'IN',
									Email: location.state.formData
										? location.state.formData.email
										: '',
									IsLeadPax: true,
									FFAirlineCode: null,
									FFNumber: '',
									GSTCompanyAddress: '',
									GSTCompanyContactNumber: '',
									GSTCompanyName: '',
									GSTNumber: '',
									GSTCompanyEmail: '',
								};
							}),
							Baggage: [],
							MealDynamic: [],
							SeatDynamic: [],
						};
						console.log('FormData', formDataLCC);
						dispatch(
							FlightTicketLCCDispatch(
								formDataLCC,
								history,
								location.state,
								agentlogin
							)
						);
					} else if (location.state.selectedReturn[0].IsLCC === false) {
						console.log('ISlcc');
						let formData = {
							TraceId: location.state.IDTBO,
							ResultIndex: location.state.selectedReturn[0].ResultIndex,
							orderId: location.state.orderID,
							paymentId:
								response === 'success' ? invoice : response.razorpay_payment_id,
							Passengers: BookingFormData.map((item) => {
								return {
									Title: item.title,
									FirstName: item.firstname,
									LastName: item.lastname,
									PaxType: item.PaxType,
									DateOfBirth: item.dob ? item.dob : '1998-03-09',
									Gender: 1,
									PassportNo: item.passportnumber ? item.passportnumber : '',
									PassportExpiry: item.expiry ? item.expiry : '',
									AddressLine1: 'demoaddress',
									AddressLine2: '',
									Fare: {
										Currency: location.state.selectedReturn[0]
											? location.state.selectedReturn[0].Fare.Currency
											: '',
										BaseFare: location.state.selectedReturn[0]
											? location.state.selectedReturn[0].Fare.OfferedFare
											: '',
										Tax: location.state.selectedReturn[0]
											? location.state.selectedReturn[0].Fare.Tax
											: '',
										YQTax: location.state.selectedReturn[0]
											? location.state.selectedReturn[0].Fare.YQTax
											: '',
										AdditionalTxnFeePub: location.state.selectedReturn[0]
											? location.state.selectedReturn[0].Fare
													.AdditionalTxnFeePub
											: '',
										AdditionalTxnFeeOfrd: location.state.selectedReturn[0]
											? location.state.selectedReturn[0].Fare
													.AdditionalTxnFeeOfrd
											: '',
										OtherCharges: location.state.selectedReturn[0]
											? location.state.selectedReturn[0].Fare.OtherCharges
											: '',
										Discount: location.state.selectedReturn[0]
											? location.state.selectedReturn[0].Fare.Discount
											: '',
										PublishedFare: location.state.selectedReturn[0]
											? location.state.selectedReturn[0].Fare.PublishedFare
											: '',
										OfferedFare: location.state.selectedReturn[0]
											? location.state.selectedReturn[0].Fare.OfferedFare
											: '',
										TdsOnCommission: location.state.selectedReturn[0]
											? location.state.selectedReturn[0].Fare.TdsOnCommission
											: '',
										TdsOnPLB: location.state.selectedReturn[0]
											? location.state.selectedReturn[0].Fare.TdsOnPLB
											: '',
										TdsOnIncentive: location.state.selectedReturn[0]
											? location.state.selectedReturn[0].Fare.TdsOnIncentive
											: '',
										ServiceFee: location.state.selectedReturn[0]
											? location.state.selectedReturn[0].Fare.ServiceFee
											: '',
									},
									City: 'demo',
									CountryCode: 'IN',
									CellCountryCode: '+91',
									ContactNo: location.state.formData
										? location.state.formData.phone
										: '',
									Nationality: 'IN',
									Email: location.state.formData
										? location.state.formData.email
										: '',
									IsLeadPax: true,
									FFAirlineCode: null,
									FFNumber: '',
									GSTCompanyAddress: '',
									GSTCompanyContactNumber: '',
									GSTCompanyName: '',
									GSTNumber: '',
									GSTCompanyEmail: '',
								};
							}),
							Baggage: [],
							MealDynamic: [],
							SeatDynamic: [],
						};
						dispatch(
							FlightBookDispatch(formData, history, location.state.IDTBO)
						);
					}
				}
			} else if (etravrtboo) {
				if (payment === 'offline') {
					let debit = {
						orderId: location.state.orderID,
						paymentId:
							payment === 'offline' ? invoice : response.razorpay_payment_id,
					};
					dispatch(flightDebitAmount(debit));
				}
				if (location.state.selectedReturn[0]?.Airline_Code) {
					let formEtrav = {
						Customer_Mobile: location.state.formData.phone,
						Passenger_Mobile: location.state.formData.phone,
						orderId: location.state.orderID,
						paymentId:
							payment === 'offline' ? invoice : response.razorpay_payment_id,
						WhatsAPP_Mobile: null,
						Passenger_Email: location.state.formData
							? location.state.formData.email
							: '',
						PAX_Details: BookingFormData.map((item, index) => {
							return {
								Pax_Id: index + 1,
								Pax_type: item.PaxType - 1,
								Title: item.title,
								First_Name: item.firstname,
								Last_Name: item.lastname,
								Gender: 0,
								Age: null,
								DOB: item.dob ? item.dob : '1998-03-09',
								Passport_Number: item.passportnumber
									? item.passportnumber
									: null,
								Passport_Issuing_Country: null,
								Passport_Expiry: item.expiry ? item.expiry : null,
								Nationality: null,
								FrequentFlyerDetails: null,
							};
						}),

						GST: true,
						GST_Number: '',
						GST_HolderName: 'GST Holder Name',
						GST_Address: 'GST Address',
						BookingFlightDetails: fareQuoteEtrav.result.AirRepriceResponses.map(
							(item) => {
								return {
									Search_Key: location.state.IDEtrav,
									Flight_Key: item.Flight.Flight_Key,
									BookingSSRDetails: [],
								};
							}
						),
						CostCenterId: 0,
						ProjectId: 0,
						BookingRemark: `${location.state.returnBody.Segments[0].Origin}-${location.state.returnBody.Segments[0].Destination} ${location.state.returnBody.Segments[0].PreferredDepartureTime} ${invoice}`,
						CorporateStatus: 0,
						CorporatePaymentMode: 0,
						MissedSavingReason: null,
						CorpTripType: null,
						CorpTripSubType: null,
						TripRequestId: null,
						BookingAlertIds: null,
					};
					// console.log("first",formEtrav)
					dispatch(
						FlightBookEtravDispatch(
							formEtrav,
							history,
							payment,
							location.state,
							agentlogin
						)
					);
				}
				if (location.state.selectedonward[0]?.AirlineCode) {
					if (location.state.selectedonward[0].IsLCC) {
						console.log('LCC');
						let formDataLCC = {
							TraceId: location.state.IDTBO,
							ResultIndex: location.state.selectedonward[0].ResultIndex,
							orderId: location.state.orderID,
							paymentId:
								payment === 'offline' ? invoice : response.razorpay_payment_id,
							Passengers: BookingFormData.map((item) => {
								return {
									Title: item.title,
									FirstName: item.firstname,
									LastName: item.lastname,
									PaxType: item.PaxType,
									DateOfBirth: item.dob ? item.dob : '1998-03-09',
									Gender: 1,
									PassportNo: item.passportnumber ? item.passportnumber : '',
									PassportExpiry: item.expiry ? item.expiry : '',
									AddressLine1: 'demoaddress',
									AddressLine2: '',
									Fare: {
										Currency: location.state.selectedonward[0]
											? location.state.selectedonward[0].Fare.Currency
											: '',
										BaseFare: location.state.selectedonward[0]
											? location.state.selectedonward[0].Fare.OfferedFare
											: '',
										Tax: location.state.selectedonward[0]
											? location.state.selectedonward[0].Fare.Tax
											: '',
										YQTax: location.state.selectedonward[0]
											? location.state.selectedonward[0].Fare.YQTax
											: '',
										AdditionalTxnFeePub: location.state.selectedonward[0]
											? location.state.selectedonward[0].Fare
													.AdditionalTxnFeePub
											: '',
										AdditionalTxnFeeOfrd: location.state.selectedonward[0]
											? location.state.selectedonward[0].Fare
													.AdditionalTxnFeeOfrd
											: '',
										OtherCharges: location.state.selectedonward[0]
											? location.state.selectedonward[0].Fare.OtherCharges
											: '',
										Discount: location.state.selectedonward[0]
											? location.state.selectedonward[0].Fare.Discount
											: '',
										PublishedFare: location.state.selectedonward[0]
											? location.state.selectedonward[0].Fare.PublishedFare
											: '',
										OfferedFare: location.state.selectedonward[0]
											? location.state.selectedonward[0].Fare.OfferedFare
											: '',
										TdsOnCommission: location.state.selectedonward[0]
											? location.state.selectedonward[0].Fare.TdsOnCommission
											: '',
										TdsOnPLB: location.state.selectedonward[0]
											? location.state.selectedonward[0].Fare.TdsOnPLB
											: '',
										TdsOnIncentive: location.state.selectedonward[0]
											? location.state.selectedonward[0].Fare.TdsOnIncentive
											: '',
										ServiceFee: location.state.selectedonward[0]
											? location.state.selectedonward[0].Fare.ServiceFee
											: '',
									},
									City: 'demo',
									CountryCode: 'IN',
									CellCountryCode: '+91',
									ContactNo: location.state.formData
										? location.state.formData.phone
										: '',
									Nationality: 'IN',
									Email: location.state.formData
										? location.state.formData.email
										: '',
									IsLeadPax: true,
									FFAirlineCode: null,
									FFNumber: '',
									GSTCompanyAddress: '',
									GSTCompanyContactNumber: '',
									GSTCompanyName: '',
									GSTNumber: '',
									GSTCompanyEmail: '',
								};
							}),
							Baggage: [],
							MealDynamic: [],
							SeatDynamic: [],
						};
						console.log('FormData', formDataLCC);
						dispatch(
							FlightTicketLCCDispatch(
								formDataLCC,
								history,
								location.state,
								agentlogin
							)
						);
					} else if (location.state.selectedonward[0]?.IsLCC === false) {
						let formData = {
							TraceId: location.state.IDTBO,
							ResultIndex: location.state.selectedonward[0].ResultIndex,
							orderId: location.state.orderID,
							paymentId:
								payment === 'offline' ? invoice : response.razorpay_payment_id,
							Passengers: BookingFormData.map((item) => {
								return {
									Title: item.title,
									FirstName: item.firstname,
									LastName: item.lastname,
									PaxType: item.PaxType,
									DateOfBirth: item.dob ? item.dob : '1998-03-09',
									Gender: 1,
									PassportNo: item.passportnumber ? item.passportnumber : '',
									PassportExpiry: item.expiry ? item.expiry : '',
									AddressLine1: 'demoaddress',
									AddressLine2: '',
									Fare: {
										Currency: location.state.selectedonward[0]
											? location.state.selectedonward[0].Fare.Currency
											: '',
										BaseFare: location.state.selectedonward[0]
											? location.state.selectedonward[0].Fare.OfferedFare
											: '',
										Tax: location.state.selectedonward[0]
											? location.state.selectedonward[0].Fare.Tax
											: '',
										YQTax: location.state.selectedonward[0]
											? location.state.selectedonward[0].Fare.YQTax
											: '',
										AdditionalTxnFeePub: location.state.selectedonward[0]
											? location.state.selectedonward[0].Fare
													.AdditionalTxnFeePub
											: '',
										AdditionalTxnFeeOfrd: location.state.selectedonward[0]
											? location.state.selectedonward[0].Fare
													.AdditionalTxnFeeOfrd
											: '',
										OtherCharges: location.state.selectedonward[0]
											? location.state.selectedonward[0].Fare.OtherCharges
											: '',
										Discount: location.state.selectedonward[0]
											? location.state.selectedonward[0].Fare.Discount
											: '',
										PublishedFare: location.state.selectedonward[0]
											? location.state.selectedonward[0].Fare.PublishedFare
											: '',
										OfferedFare: location.state.selectedonward[0]
											? location.state.selectedonward[0].Fare.OfferedFare
											: '',
										TdsOnCommission: location.state.selectedonward[0]
											? location.state.selectedonward[0].Fare.TdsOnCommission
											: '',
										TdsOnPLB: location.state.selectedonward[0]
											? location.state.selectedonward[0].Fare.TdsOnPLB
											: '',
										TdsOnIncentive: location.state.selectedonward[0]
											? location.state.selectedonward[0].Fare.TdsOnIncentive
											: '',
										ServiceFee: location.state.selectedonward[0]
											? location.state.selectedonward[0].Fare.ServiceFee
											: '',
									},
									City: 'demo',
									CountryCode: 'IN',
									CellCountryCode: '+91',
									ContactNo: location.state.formData
										? location.state.formData.phone
										: '',
									Nationality: 'IN',
									Email: location.state.formData
										? location.state.formData.email
										: '',
									IsLeadPax: true,
									FFAirlineCode: null,
									FFNumber: '',
									GSTCompanyAddress: '',
									GSTCompanyContactNumber: '',
									GSTCompanyName: '',
									GSTNumber: '',
									GSTCompanyEmail: '',
								};
							}),
							Baggage: [],
							MealDynamic: [],
							SeatDynamic: [],
						};
						dispatch(
							FlightBookDispatch(formData, history, location.state.IDTBO)
						);
					}
				}
			} else if (
				location.state.selectedonward[0]?.Supplier === 'TJK' &&
				location.state.selectedReturn[0]?.Supplier === 'TJK'
			) {
				let formDataTJK = {
					bookingId: farequotetripjack.result.bookingId,
					paymentInfos: [
						{
							amount:
								farequotetripjack.result.totalPriceInfo.totalFareDetail.fC.TF,
						},
					],
					travellerInfo: BookingFormData.map((item, index) => {
						return {
							ti: item.title,
							fN: item.firstname,
							lN: item.lastname,
							pt:
								item.PaxType == 1
									? 'ADULT'
									: item.PaxType == 2
									? 'CHILD'
									: item.PaxType == 3
									? 'INFANT'
									: '',
							dob: item.dob ? item.dob : '1996-04-09',
							pNat: 'IN',
							pid: '2021-09-08',
							pNum: item.passportnumber ? item.passportnumber : null,
							eD: item.expiry ? item.expiry : null,
						};
					}),
					gstInfo: {
						gstNumber: '18AABCU9603R1ZM',
						email: 'apitest2ER@apitest.com ',
						registeredName: 'XYZ Pvt Ltd',
						mobile: '+918890005606',
						address: 'Dhanbad',
					},
					deliveryInfo: {
						emails: [location.state.formData.email],
						contacts: [location.state.formData.phone],
					},
				};
				dispatch(FlightBookTripJackDispatch(formDataTJK, history));
			}
		}
		if (location.state.intFlight) {
			console.log('first');
			if (location.state.intFlight.IsLCC) {
				console.log('LCC');
				let formDataLCC = {
					TraceId: location.state.IDTBO,
					ResultIndex: location.state.intFlight.ResultIndex,
					orderId: location.state.orderID,
					paymentId:
						response === 'success' ? invoice : response.razorpay_payment_id,
					Passengers: BookingFormData.map((item) => {
						return {
							Title: item.title,
							FirstName: item.firstname,
							LastName: item.lastname,
							PaxType: item.PaxType,
							DateOfBirth: item.dob ? item.dob : '1998-03-09',
							Gender: 1,
							PassportNo: item.passportnumber ? item.passportnumber : '',
							PassportExpiry: item.expiry ? item.expiry : '',
							AddressLine1: 'demoaddress',
							AddressLine2: '',
							Fare: {
								Currency: location.state.intFlight
									? location.state.intFlight.Fare.Currency
									: '',
								BaseFare: location.state.intFlight
									? location.state.intFlight.Fare.OfferedFare
									: '',
								Tax: location.state.intFlight
									? location.state.intFlight.Fare.Tax
									: '',
								YQTax: location.state.intFlight
									? location.state.intFlight.Fare.YQTax
									: '',
								AdditionalTxnFeePub: location.state.intFlight
									? location.state.intFlight.Fare.AdditionalTxnFeePub
									: '',
								AdditionalTxnFeeOfrd: location.state.intFlight
									? location.state.intFlight.Fare.AdditionalTxnFeeOfrd
									: '',
								OtherCharges: location.state.intFlight
									? location.state.intFlight.Fare.OtherCharges
									: '',
								Discount: location.state.intFlight
									? location.state.intFlight.Fare.Discount
									: '',
								PublishedFare: location.state.intFlight
									? location.state.intFlight.Fare.PublishedFare
									: '',
								OfferedFare: location.state.intFlight
									? location.state.intFlight.Fare.OfferedFare
									: '',
								TdsOnCommission: location.state.intFlight
									? location.state.intFlight.Fare.TdsOnCommission
									: '',
								TdsOnPLB: location.state.intFlight
									? location.state.intFlight.Fare.TdsOnPLB
									: '',
								TdsOnIncentive: location.state.intFlight
									? location.state.intFlight.Fare.TdsOnIncentive
									: '',
								ServiceFee: location.state.intFlight
									? location.state.intFlight.Fare.ServiceFee
									: '',
							},
							City: '',
							CountryCode: 'IN',
							CellCountryCode: '+91',
							ContactNo: location.state.formData
								? location.state.formData.phone
								: '',
							Nationality: 'IN',
							Email: location.state.formData
								? location.state.formData.email
								: '',
							IsLeadPax: true,
							FFAirlineCode: null,
							FFNumber: '',
							GSTCompanyAddress: '',
							GSTCompanyContactNumber: '',
							GSTCompanyName: '',
							GSTNumber: '',
							GSTCompanyEmail: '',
						};
					}),
					Baggage: [],
					MealDynamic: [],
					SeatDynamic: [],
				};
				console.log('FormData', formDataLCC);
				dispatch(
					FlightTicketLCCDispatch(
						formDataLCC,
						history,
						location.state,
						agentlogin
					)
				);
			} else if (location.state.intFlight.IsLCC === false) {
				let formData = {
					TraceId: location.state.IDTBO,
					ResultIndex: location.state.intFlight.ResultIndex,
					orderId: location.state.orderID,
					paymentId:
						response === 'success' ? invoice : response.razorpay_payment_id,
					Passengers: BookingFormData.map((item) => {
						return {
							Title: item.title,
							FirstName: item.firstname,
							LastName: item.lastname,
							PaxType: item.PaxType,
							DateOfBirth: item.dob ? item.dob : '1998-03-09',
							Gender: 1,
							PassportNo: item.passportnumber ? item.passportnumber : '',
							PassportExpiry: item.expiry ? item.expiry : '',
							AddressLine1: 'demoaddress',
							AddressLine2: '',
							Fare: {
								Currency: location.state.intFlight
									? location.state.intFlight.Fare.Currency
									: '',
								BaseFare: location.state.intFlight
									? location.state.intFlight.Fare.OfferedFare
									: '',
								Tax: location.state.intFlight
									? location.state.intFlight.Fare.Tax
									: '',
								YQTax: location.state.intFlight
									? location.state.intFlight.Fare.YQTax
									: '',
								AdditionalTxnFeePub: location.state.intFlight
									? location.state.intFlight.Fare.AdditionalTxnFeePub
									: '',
								AdditionalTxnFeeOfrd: location.state.intFlight
									? location.state.intFlight.Fare.AdditionalTxnFeeOfrd
									: '',
								OtherCharges: location.state.intFlight
									? location.state.intFlight.Fare.OtherCharges
									: '',
								Discount: location.state.intFlight
									? location.state.intFlight.Fare.Discount
									: '',
								PublishedFare: location.state.intFlight
									? location.state.intFlight.Fare.PublishedFare
									: '',
								OfferedFare: location.state.intFlight
									? location.state.intFlight.Fare.OfferedFare
									: '',
								TdsOnCommission: location.state.intFlight
									? location.state.intFlight.Fare.TdsOnCommission
									: '',
								TdsOnPLB: location.state.intFlight
									? location.state.intFlight.Fare.TdsOnPLB
									: '',
								TdsOnIncentive: location.state.intFlight
									? location.state.intFlight.Fare.TdsOnIncentive
									: '',
								ServiceFee: location.state.intFlight
									? location.state.intFlight.Fare.ServiceFee
									: '',
							},
							City: '',
							CountryCode: 'IN',
							CellCountryCode: '+91',
							ContactNo: location.state.formData
								? location.state.formData.phone
								: '',
							Nationality: 'IN',
							Email: location.state.formData
								? location.state.formData.email
								: '',
							IsLeadPax: true,
							FFAirlineCode: null,
							FFNumber: '',
							GSTCompanyAddress: '',
							GSTCompanyContactNumber: '',
							GSTCompanyName: '',
							GSTNumber: '',
							GSTCompanyEmail: '',
						};
					}),
					Baggage: [],
					MealDynamic: [],
					SeatDynamic: [],
				};
				dispatch(FlightBookDispatch(formData, history, location.state.IDTBO));
			}
		}
	};
	const PGCharge = 200;
	const handleFormSubmit = (data) => {
		const selectedFlight = location.state.OneflightData;
		const priceDetails = fareQuoteEtrav
			? fareQuoteEtrav.result?.AirRepriceResponses[0].Flight
			: fareQuote
			? fareQuote.result?.Response.Results
			: farequotetripjack
			? farequotetripjack.result
			: '';
		const priceDetails2 = fareQuote ? fareQuote.result?.Response.Results : '';
		const priceDetails3 = fareQuoteReturn
			? fareQuoteReturn.result?.Response.Results
			: '';
		const payableAmout = location.state.OneflightData
			? location.state.OneflightData?.Supplier === 'ETR'
				? Number(
						Math.round(
							fareQuoteEtrav
								? fareQuoteEtrav?.result?.AirRepriceResponses[0].Flight.Fares
										.Total_Amount
								: location.state.OneflightData?.Fares.Total_Amount
						)
				  ) -
				  Number(Math.round(location.state.OneflightData?.Fares?.agentMarkup)) +
				  Number(
						(Number(
							Number(
								Math.round(
									fareQuoteEtrav
										? fareQuoteEtrav?.result?.AirRepriceResponses[0].Flight
												.Fares.Total_Amount
										: location.state.OneflightData.Fares.Total_Amount
								)
							) -
								Number(
									Math.round(location.state.OneflightData?.Fares?.agentMarkup)
								)
						) *
							2.5) /
							100
				  )
				: // +
				// Number(
				//   Math.round(
				//     baggageAdult1?.AirlineCode
				//       ? baggageAdult1?.Price
				//       : baggageAdult1?.code
				//       ? baggageAdult1?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     baggageAdult2?.AirlineCode
				//       ? baggageAdult2?.Price
				//       : baggageAdult2?.code
				//       ? baggageAdult2?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     baggageAdult3?.AirlineCode
				//       ? baggageAdult3?.Price
				//       : baggageAdult3?.code
				//       ? baggageAdult3?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     baggageAdult4?.AirlineCode
				//       ? baggageAdult4?.Price
				//       : baggageAdult4?.code
				//       ? baggageAdult4?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     baggageAdult5?.AirlineCode
				//       ? baggageAdult5?.Price
				//       : baggageAdult5?.code
				//       ? baggageAdult5?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     baggageAdult6?.AirlineCode
				//       ? baggageAdult6?.Price
				//       : baggageAdult6?.code
				//       ? baggageAdult6?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     baggageAdult7?.AirlineCode
				//       ? baggageAdult7?.Price
				//       : baggageAdult7?.code
				//       ? baggageAdult7?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     baggageAdult8?.AirlineCode
				//       ? baggageAdult8?.Price
				//       : baggageAdult8?.code
				//       ? baggageAdult8?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     baggageAdult9?.AirlineCode
				//       ? baggageAdult9?.Price
				//       : baggageAdult9?.code
				//       ? baggageAdult9?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     baggageChild1?.AirlineCode
				//       ? baggageChild1?.Price
				//       : baggageChild1?.code
				//       ? baggageChild1?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     baggageChild2?.AirlineCode
				//       ? baggageChild2?.Price
				//       : baggageChild2?.code
				//       ? baggageChild2?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     baggageChild3?.AirlineCode
				//       ? baggageChild3?.Price
				//       : baggageChild3?.code
				//       ? baggageChild3?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     baggageChild4?.AirlineCode
				//       ? baggageChild4?.Price
				//       : baggageChild4?.code
				//       ? baggageChild4?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     baggageChild5?.AirlineCode
				//       ? baggageChild5?.Price
				//       : baggageChild5?.code
				//       ? baggageChild5?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     baggageChild6?.AirlineCode
				//       ? baggageChild6?.Price
				//       : baggageChild6?.code
				//       ? baggageChild6?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     mealAdult1?.AirlineCode
				//       ? mealAdult1?.Price
				//       : mealAdult1?.code
				//       ? mealAdult1?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     mealAdult2?.AirlineCode
				//       ? mealAdult2?.Price
				//       : mealAdult2?.code
				//       ? mealAdult2?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     mealAdult3?.AirlineCode
				//       ? mealAdult3?.Price
				//       : mealAdult3?.code
				//       ? mealAdult3?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     mealAdult4?.AirlineCode
				//       ? mealAdult4?.Price
				//       : mealAdult4?.code
				//       ? mealAdult4?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     mealAdult5?.AirlineCode
				//       ? mealAdult5?.Price
				//       : mealAdult5?.code
				//       ? mealAdult5?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     mealAdult6?.AirlineCode
				//       ? mealAdult6?.Price
				//       : mealAdult6?.code
				//       ? mealAdult6?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     mealAdult7?.AirlineCode
				//       ? mealAdult7?.Price
				//       : mealAdult7?.code
				//       ? mealAdult7?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     mealAdult8?.AirlineCode
				//       ? mealAdult8?.Price
				//       : mealAdult8?.code
				//       ? mealAdult8?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     mealAdult9?.AirlineCode
				//       ? mealAdult9?.Price
				//       : mealAdult9?.code
				//       ? mealAdult9?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     mealChild1?.AirlineCode
				//       ? mealChild1?.Price
				//       : mealChild1?.code
				//       ? mealChild1?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     mealChild2?.AirlineCode
				//       ? mealChild2?.Price
				//       : mealChild2?.code
				//       ? mealChild2?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     mealChild3?.AirlineCode
				//       ? mealChild3?.Price
				//       : mealChild3?.code
				//       ? mealChild3?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     mealChild4?.AirlineCode
				//       ? mealChild4?.Price
				//       : mealChild4?.code
				//       ? mealChild4?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     mealChild5?.AirlineCode
				//       ? mealChild5?.Price
				//       : mealChild5?.code
				//       ? mealChild5?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     mealChild6?.AirlineCode
				//       ? mealChild6?.Price
				//       : mealChild6?.code
				//       ? mealChild6?.amount
				//       : 0
				//   )
				// )
				location.state.OneflightData?.Supplier === 'TBO'
				? Number(
						Number(
							Math.round(
								fareQuote
									? fareQuote?.result.Response.Results.Fare.Total_Amount
									: location.state.OneflightData?.Fare?.Total_Amount
							)
						) -
							Number(
								Math.round(
									fareQuote
										? fareQuote?.result.Response.Results.Fare.MFB_Discount
										: location.state.OneflightData?.Fare?.MFB_Discount
								)
							) -
							Number(
								Math.round(location.state.OneflightData?.Fare?.agentMarkup)
							)
				  ) +
				  Number(
						(Number(
							Number(
								Math.round(
									fareQuote
										? fareQuote?.result.Response.Results.Fare.Total_Amount
										: location.state.OneflightData?.Fare?.Total_Amount
								)
							) -
								Number(
									Math.round(
										fareQuote
											? fareQuote?.result.Response.Results.Fare.MFB_Discount
											: location.state.OneflightData?.Fare?.MFB_Discount
									)
								) -
								Number(
									Math.round(location.state.OneflightData?.Fare?.agentMarkup)
								)
						) *
							2.5) /
							100
				  )
				: // +
				// Number(
				//   Math.round(
				//     baggageAdult1?.AirlineCode
				//       ? baggageAdult1?.Price
				//       : baggageAdult1?.code
				//       ? baggageAdult1?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     baggageAdult2?.AirlineCode
				//       ? baggageAdult2?.Price
				//       : baggageAdult2?.code
				//       ? baggageAdult2?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     baggageAdult3?.AirlineCode
				//       ? baggageAdult3?.Price
				//       : baggageAdult3?.code
				//       ? baggageAdult3?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     baggageAdult4?.AirlineCode
				//       ? baggageAdult4?.Price
				//       : baggageAdult4?.code
				//       ? baggageAdult4?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     baggageAdult5?.AirlineCode
				//       ? baggageAdult5?.Price
				//       : baggageAdult5?.code
				//       ? baggageAdult5?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     baggageAdult6?.AirlineCode
				//       ? baggageAdult6?.Price
				//       : baggageAdult6?.code
				//       ? baggageAdult6?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     baggageAdult7?.AirlineCode
				//       ? baggageAdult7?.Price
				//       : baggageAdult7?.code
				//       ? baggageAdult7?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     baggageAdult8?.AirlineCode
				//       ? baggageAdult8?.Price
				//       : baggageAdult8?.code
				//       ? baggageAdult8?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     baggageAdult9?.AirlineCode
				//       ? baggageAdult9?.Price
				//       : baggageAdult9?.code
				//       ? baggageAdult9?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     baggageChild1?.AirlineCode
				//       ? baggageChild1?.Price
				//       : baggageChild1?.code
				//       ? baggageChild1?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     baggageChild2?.AirlineCode
				//       ? baggageChild2?.Price
				//       : baggageChild2?.code
				//       ? baggageChild2?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     baggageChild3?.AirlineCode
				//       ? baggageChild3?.Price
				//       : baggageChild3?.code
				//       ? baggageChild3?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     baggageChild4?.AirlineCode
				//       ? baggageChild4?.Price
				//       : baggageChild4?.code
				//       ? baggageChild4?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     baggageChild5?.AirlineCode
				//       ? baggageChild5?.Price
				//       : baggageChild5?.code
				//       ? baggageChild5?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     baggageChild6?.AirlineCode
				//       ? baggageChild6?.Price
				//       : baggageChild6?.code
				//       ? baggageChild6?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     mealAdult1?.AirlineCode
				//       ? mealAdult1?.Price
				//       : mealAdult1?.code
				//       ? mealAdult1?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     mealAdult2?.AirlineCode
				//       ? mealAdult2?.Price
				//       : mealAdult2?.code
				//       ? mealAdult2?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     mealAdult3?.AirlineCode
				//       ? mealAdult3?.Price
				//       : mealAdult3?.code
				//       ? mealAdult3?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     mealAdult4?.AirlineCode
				//       ? mealAdult4?.Price
				//       : mealAdult4?.code
				//       ? mealAdult4?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     mealAdult5?.AirlineCode
				//       ? mealAdult5?.Price
				//       : mealAdult5?.code
				//       ? mealAdult5?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     mealAdult6?.AirlineCode
				//       ? mealAdult6?.Price
				//       : mealAdult6?.code
				//       ? mealAdult6?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     mealAdult7?.AirlineCode
				//       ? mealAdult7?.Price
				//       : mealAdult7?.code
				//       ? mealAdult7?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     mealAdult8?.AirlineCode
				//       ? mealAdult8?.Price
				//       : mealAdult8?.code
				//       ? mealAdult8?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     mealAdult9?.AirlineCode
				//       ? mealAdult9?.Price
				//       : mealAdult9?.code
				//       ? mealAdult9?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     mealChild1?.AirlineCode
				//       ? mealChild1?.Price
				//       : mealChild1?.code
				//       ? mealChild1?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     mealChild2?.AirlineCode
				//       ? mealChild2?.Price
				//       : mealChild2?.code
				//       ? mealChild2?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     mealChild3?.AirlineCode
				//       ? mealChild3?.Price
				//       : mealChild3?.code
				//       ? mealChild3?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     mealChild4?.AirlineCode
				//       ? mealChild4?.Price
				//       : mealChild4?.code
				//       ? mealChild4?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     mealChild5?.AirlineCode
				//       ? mealChild5?.Price
				//       : mealChild5?.code
				//       ? mealChild5?.amount
				//       : 0
				//   )
				// ) +
				// Number(
				//   Math.round(
				//     mealChild6?.AirlineCode
				//       ? mealChild6?.Price
				//       : mealChild6?.code
				//       ? mealChild6?.amount
				//       : 0
				//   )
				// )
				location.state.OneflightData?.Supplier === 'TJK'
				? Number(
						Math.round(
							location.state.OneflightData?.totalPriceList?.fd.Total_Amount
						)
				  ) -
				  Number(
						Math.round(
							location.state.OneflightData?.totalPriceList?.fd.agentMarkup
						)
				  ) +
				  Number(
						(Number(
							Number(
								Math.round(
									location.state.OneflightData?.totalPriceList?.fd.Total_Amount
								)
							) -
								Number(
									Math.round(
										location.state.OneflightData?.totalPriceList?.fd.agentMarkup
									)
								)
						) *
							2.5) /
							100
				  )
				: //  +
				  // Number(
				  //   Math.round(
				  //     baggageAdult1?.AirlineCode
				  //       ? baggageAdult1?.Price
				  //       : baggageAdult1?.code
				  //       ? baggageAdult1?.amount
				  //       : 0
				  //   )
				  // ) +
				  // Number(
				  //   Math.round(
				  //     baggageAdult2?.AirlineCode
				  //       ? baggageAdult2?.Price
				  //       : baggageAdult2?.code
				  //       ? baggageAdult2?.amount
				  //       : 0
				  //   )
				  // ) +
				  // Number(
				  //   Math.round(
				  //     baggageAdult3?.AirlineCode
				  //       ? baggageAdult3?.Price
				  //       : baggageAdult3?.code
				  //       ? baggageAdult3?.amount
				  //       : 0
				  //   )
				  // ) +
				  // Number(
				  //   Math.round(
				  //     baggageAdult4?.AirlineCode
				  //       ? baggageAdult4?.Price
				  //       : baggageAdult4?.code
				  //       ? baggageAdult4?.amount
				  //       : 0
				  //   )
				  // ) +
				  // Number(
				  //   Math.round(
				  //     baggageAdult5?.AirlineCode
				  //       ? baggageAdult5?.Price
				  //       : baggageAdult5?.code
				  //       ? baggageAdult5?.amount
				  //       : 0
				  //   )
				  // ) +
				  // Number(
				  //   Math.round(
				  //     baggageAdult6?.AirlineCode
				  //       ? baggageAdult6?.Price
				  //       : baggageAdult6?.code
				  //       ? baggageAdult6?.amount
				  //       : 0
				  //   )
				  // ) +
				  // Number(
				  //   Math.round(
				  //     baggageAdult7?.AirlineCode
				  //       ? baggageAdult7?.Price
				  //       : baggageAdult7?.code
				  //       ? baggageAdult7?.amount
				  //       : 0
				  //   )
				  // ) +
				  // Number(
				  //   Math.round(
				  //     baggageAdult8?.AirlineCode
				  //       ? baggageAdult8?.Price
				  //       : baggageAdult8?.code
				  //       ? baggageAdult8?.amount
				  //       : 0
				  //   )
				  // ) +
				  // Number(
				  //   Math.round(
				  //     baggageAdult9?.AirlineCode
				  //       ? baggageAdult9?.Price
				  //       : baggageAdult9?.code
				  //       ? baggageAdult9?.amount
				  //       : 0
				  //   )
				  // ) +
				  // Number(
				  //   Math.round(
				  //     baggageChild1?.AirlineCode
				  //       ? baggageChild1?.Price
				  //       : baggageChild1?.code
				  //       ? baggageChild1?.amount
				  //       : 0
				  //   )
				  // ) +
				  // Number(
				  //   Math.round(
				  //     baggageChild2?.AirlineCode
				  //       ? baggageChild2?.Price
				  //       : baggageChild2?.code
				  //       ? baggageChild2?.amount
				  //       : 0
				  //   )
				  // ) +
				  // Number(
				  //   Math.round(
				  //     baggageChild3?.AirlineCode
				  //       ? baggageChild3?.Price
				  //       : baggageChild3?.code
				  //       ? baggageChild3?.amount
				  //       : 0
				  //   )
				  // ) +
				  // Number(
				  //   Math.round(
				  //     baggageChild4?.AirlineCode
				  //       ? baggageChild4?.Price
				  //       : baggageChild4?.code
				  //       ? baggageChild4?.amount
				  //       : 0
				  //   )
				  // ) +
				  // Number(
				  //   Math.round(
				  //     baggageChild5?.AirlineCode
				  //       ? baggageChild5?.Price
				  //       : baggageChild5?.code
				  //       ? baggageChild5?.amount
				  //       : 0
				  //   )
				  // ) +
				  // Number(
				  //   Math.round(
				  //     baggageChild6?.AirlineCode
				  //       ? baggageChild6?.Price
				  //       : baggageChild6?.code
				  //       ? baggageChild6?.amount
				  //       : 0
				  //   )
				  // ) +
				  // Number(
				  //   Math.round(
				  //     mealAdult1?.AirlineCode
				  //       ? mealAdult1?.Price
				  //       : mealAdult1?.code
				  //       ? mealAdult1?.amount
				  //       : 0
				  //   )
				  // ) +
				  // Number(
				  //   Math.round(
				  //     mealAdult2?.AirlineCode
				  //       ? mealAdult2?.Price
				  //       : mealAdult2?.code
				  //       ? mealAdult2?.amount
				  //       : 0
				  //   )
				  // ) +
				  // Number(
				  //   Math.round(
				  //     mealAdult3?.AirlineCode
				  //       ? mealAdult3?.Price
				  //       : mealAdult3?.code
				  //       ? mealAdult3?.amount
				  //       : 0
				  //   )
				  // ) +
				  // Number(
				  //   Math.round(
				  //     mealAdult4?.AirlineCode
				  //       ? mealAdult4?.Price
				  //       : mealAdult4?.code
				  //       ? mealAdult4?.amount
				  //       : 0
				  //   )
				  // ) +
				  // Number(
				  //   Math.round(
				  //     mealAdult5?.AirlineCode
				  //       ? mealAdult5?.Price
				  //       : mealAdult5?.code
				  //       ? mealAdult5?.amount
				  //       : 0
				  //   )
				  // ) +
				  // Number(
				  //   Math.round(
				  //     mealAdult6?.AirlineCode
				  //       ? mealAdult6?.Price
				  //       : mealAdult6?.code
				  //       ? mealAdult6?.amount
				  //       : 0
				  //   )
				  // ) +
				  // Number(
				  //   Math.round(
				  //     mealAdult7?.AirlineCode
				  //       ? mealAdult7?.Price
				  //       : mealAdult7?.code
				  //       ? mealAdult7?.amount
				  //       : 0
				  //   )
				  // ) +
				  // Number(
				  //   Math.round(
				  //     mealAdult8?.AirlineCode
				  //       ? mealAdult8?.Price
				  //       : mealAdult8?.code
				  //       ? mealAdult8?.amount
				  //       : 0
				  //   )
				  // ) +
				  // Number(
				  //   Math.round(
				  //     mealAdult9?.AirlineCode
				  //       ? mealAdult9?.Price
				  //       : mealAdult9?.code
				  //       ? mealAdult9?.amount
				  //       : 0
				  //   )
				  // ) +
				  // Number(
				  //   Math.round(
				  //     mealChild1?.AirlineCode
				  //       ? mealChild1?.Price
				  //       : mealChild1?.code
				  //       ? mealChild1?.amount
				  //       : 0
				  //   )
				  // ) +
				  // Number(
				  //   Math.round(
				  //     mealChild2?.AirlineCode
				  //       ? mealChild2?.Price
				  //       : mealChild2?.code
				  //       ? mealChild2?.amount
				  //       : 0
				  //   )
				  // ) +
				  // Number(
				  //   Math.round(
				  //     mealChild3?.AirlineCode
				  //       ? mealChild3?.Price
				  //       : mealChild3?.code
				  //       ? mealChild3?.amount
				  //       : 0
				  //   )
				  // ) +
				  // Number(
				  //   Math.round(
				  //     mealChild4?.AirlineCode
				  //       ? mealChild4?.Price
				  //       : mealChild4?.code
				  //       ? mealChild4?.amount
				  //       : 0
				  //   )
				  // ) +
				  // Number(
				  //   Math.round(
				  //     mealChild5?.AirlineCode
				  //       ? mealChild5?.Price
				  //       : mealChild5?.code
				  //       ? mealChild5?.amount
				  //       : 0
				  //   )
				  // ) +
				  // Number(
				  //   Math.round(
				  //     mealChild6?.AirlineCode
				  //       ? mealChild6?.Price
				  //       : mealChild6?.code
				  //       ? mealChild6?.amount
				  //       : 0
				  //   )
				  // )
				  ''
			: location.state.intFlight?.Supplier === 'TBO'
			? Number(Math.round(location.state.intFlight.Fare.Total_Amount)) -
			  Number(Math.round(location.state.intFlight.Fare.agentMarkup)) +
			  Number(
					(Number(
						Number(Math.round(location.state.intFlight.Fare.Total_Amount)) -
							Number(Math.round(location.state.intFlight.Fare.agentMarkup))
					) *
						2.5) /
						100
			  )
			: Number(
					Number(
						Math.round(
							location.state.selectedonward[0].Airline_Code
								? location.state.selectedonward[0].Fares.Total_Amount
								: location.state.selectedonward[0].AirlineCode
								? fareQuote
									? fareQuote?.result.Response.Results.Fare.Total_Amount
									: location.state.selectedonward[0].Fare.Total_Amount
								: 0
						)
					) +
						Number(
							Math.round(
								location.state.selectedReturn[0].Airline_Code
									? location.state.selectedReturn[0].Fares.Total_Amount
									: location.state.selectedReturn[0].AirlineCode
									? fareQuoteReturn
										? fareQuoteReturn?.result.Response.Results.Fare.Total_Amount
										: location.state.selectedReturn[0].Fare.Total_Amount
									: 0
							) -
								Number(
									Math.round(
										location.state.selectedReturn[0].Airline_Code
											? 0
											: location.state.selectedReturn[0].AirlineCode
											? fareQuoteReturn
												? fareQuoteReturn?.result?.Response.Results.Fare
														.MFB_Discount
												: location.state.selectedReturn[0].Fare.MFB_Discount
											: 0
									)
								) -
								Number(
									Math.round(
										location.state.selectedonward[0].Airline_Code
											? 0
											: location.state.selectedonward[0].AirlineCode
											? fareQuote
												? fareQuote?.result.Response.Results.Fare.MFB_Discount
												: location.state.selectedonward[0].Fare.MFB_Discount
											: 0
									)
								)
						) +
						(Number(
							Number(
								Math.round(
									location.state.selectedonward[0].Airline_Code
										? location.state.selectedonward[0].Fares.Total_Amount
										: location.state.selectedonward[0].AirlineCode
										? fareQuote
											? fareQuote?.result.Response.Results.Fare.Total_Amount
											: location.state.selectedonward[0].Fare.Total_Amount
										: 0
								)
							) +
								Number(
									Math.round(
										location.state.selectedReturn[0].Airline_Code
											? location.state.selectedReturn[0].Fares.Total_Amount
											: location.state.selectedReturn[0].AirlineCode
											? fareQuoteReturn
												? fareQuoteReturn?.result.Response.Results.Fare
														.Total_Amount
												: location.state.selectedReturn[0].Fare.Total_Amount
											: 0
									)
								) -
								Number(
									Math.round(
										location.state.selectedReturn[0].Airline_Code
											? 0
											: location.state.selectedReturn[0].AirlineCode
											? fareQuoteReturn
												? fareQuoteReturn?.result?.Response.Results.Fare
														.MFB_Discount
												: location.state.selectedReturn[0].Fare.MFB_Discount
											: 0
									)
								) -
								Number(
									Math.round(
										location.state.selectedonward[0].Airline_Code
											? 0
											: location.state.selectedonward[0].AirlineCode
											? fareQuote
												? fareQuote?.result.Response.Results.Fare.MFB_Discount
												: location.state.selectedonward[0].Fare.MFB_Discount
											: 0
									)
								)
						) *
							2.5) /
							100
			  );

		if (location.state.selectedonward) {
			addBookingReturn(
				location,
				agentlogin,
				payment,
				payableAmout,
				priceDetails2,
				priceDetails3,
				selectedFlight,
				dispatch,
				FlightAddBookingDispatch,
				PGCharge,
				BookingFormData,
				fareQuoteEtrav,
				fareQuote,
				fareQuoteReturn
			);
			// addBookingReturnEtrav(
			// 		location,
			// 	agentlogin,
			// 	payment,
			// 	payableAmout,
			// 	priceDetails2,
			// 	priceDetails3,
			// 	selectedFlight,
			// 	dispatch,
			// 	FlightAddBookingDispatch,
			// 	PGCharge,
			// 	BookingFormData
			// )
		} else if (
			location.state.OneflightData?.Supplier === 'ETR' ||
			location.state.OneflightData?.Supplier === 'TBO' ||
			location.state.OneflightData?.Supplier === 'TJK'
		) {
			addBooking(
				location,
				agentlogin,
				payment,
				payableAmout,
				priceDetails,
				selectedFlight,
				dispatch,
				FlightAddBookingDispatch,
				PGCharge,
				BookingFormData,
				fareQuoteEtrav,
				fareQuote
			);
		} else if (location.state.intFlight) {
			console.log('Inflight');
			addINtBooking(
				location,
				agentlogin,
				payment,
				payableAmout,
				priceDetails,
				selectedFlight,
				dispatch,
				FlightAddBookingDispatch,
				PGCharge,
				BookingFormData
			);
			// addBooking(

			// );
		} else if (location.state.OneflightData?.Supplier === 'TJK') {
		}

		// if (
		// location.state.selectedonward
		//   ? tbo2
		//     ? Number(
		//         Number(fareQuote.result.Response.Results.Fare.Total_Amount) +
		//           Number(
		//             fareQuoteReturn.result.Response.Results.Fare.Total_Amount
		//           )
		//       ) <=
		//       Number(
		//         Number(location.state.selectedReturn[0].Fare.Total_Amount) +
		//           Number(location.state.selectedonward[0].Fare.Total_Amount)
		//       )
		//     : etrav2
		//     ? Number(
		//         Number(fareQuoteEtrav.result.AirRepriceResponses[0].Flight.Fares[0]
		//           .FareDetails[0].Total_Amount) +
		//           Number(
		//             fareQuoteEtrav.result.AirRepriceResponses[1].Flight.Fares[0]
		//       .FareDetails[0].Total_Amount
		//           )
		//       ) <=
		//       Number(
		//         Number(location.state.selectedReturn[0].Fares.FareDetails[0].Total_Amount) +
		//           Number(location.state.selectedonward[0].Fares.FareDetails[0].Total_Amount)
		//       )
		//     : etrvotbor?Number(
		//       Number(fareQuoteEtrav.result.AirRepriceResponses[0].Flight.Fares[0]
		//         .FareDetails[0].Total_Amount) +
		//         Number(
		//           fareQuote.result.Response.Results.Fare.Total_Amount
		//         )
		//     ) <=
		//     Number(
		//       Number(location.state.selectedReturn[0].Fare.Total_Amount) +
		//         Number(location.state.selectedonward[0].Fares.FareDetails[0].Total_Amount)
		//     ):etravrtboo?Number(
		//       Number(fareQuoteEtrav.result.AirRepriceResponses[0].Flight.Fares[0]
		//         .FareDetails[0].Total_Amount) +
		//         Number(
		//           fareQuote.result.Response.Results.Fare.Total_Amount
		//         )
		//     ) <=
		//     Number(
		//       Number(location.state.selectedonward[0].Fare.Total_Amount) +
		//         Number(location.state.selectedReturn[0].Fares.FareDetails[0].Total_Amount)
		//     ):''
		//   : fareQuoteEtrav
		//   ? fareQuoteEtrav.result.AirRepriceResponses[0].Flight.Fares[0]
		//       .FareDetails[0].Total_Amount
		//   : fareQuote.result.Response.Results.Fare.Total_Amount <=
		//     location.state.OneflightData.Fares
		//   ? location.state.OneflightData.Fares.FareDetails[0].Total_Amount
		//   : location.state.OneflightData.Fare.Total_Amount
		// ) {
		if (payment === 'pay') {
			// e.preventDefault();
			var options = {
				// key: "rzp_test_1xufv8E9EKecYL",
				// key_secret: "Ui7h6GeBLYxy1y75QaV6TgBz",
				key: 'rzp_live_IZ3H2uQBdbxAbv',
				key_secret: 'JVXsfYLHnTU4xk8uRGvmwZ2Q',
				amount: Number(
					Math.round(Number(Number(Math.round(payableAmout)) * 100))
				),

				currency: curr,
				name: 'Flight Booking',
				description: '',
				handler: handlePayment,
				prefill: {
					name: `${location.state.formData.first_name} ${location.state.formData.last_name}`,
					email: location.state.formData.email,
					contact: location.state.formData.phone,
				},
				notes: {
					address: location.state.formData.address,
				},
				theme: {
					color: '#3399cc',
				},
			};
			var pay = new window.Razorpay(options);
			pay.open();
		} else if (payment === 'offline') {
			// let res = 'success';
			// handlePayment(res);
			dispatch(togglePGModal(true));
		} else if (payment === 'payworldline') {
			dispatch(togglePGModal(true));
		}
		// } else {
		//   // window.alert('Fare has been Changed')
		//   // dispatch(togglePriceChangeModal(true));
		// }
	};
	const handleHold = (e) => {
		if (e.target.value === 'payworldline') {
			dispatch(setPayment(e.target.value));
			if (payworldline) {
				setPay(false);
				setOffline(false);
				setPayWorldline(false);
			} else {
				setPayWorldline(true);
				setPay(false);
				setOffline(false);
			}
		} else if (e.target.value === 'pay') {
			dispatch(setPayment(e.target.value));
			if (pay) {
				setPay(false);
				setOffline(false);
				setPayWorldline(false);
			} else {
				setPay(true);
				setPayWorldline(false);
				setOffline(false);
			}
		} else if (e.target.value === 'offline') {
			dispatch(setPayment(e.target.value));
			if (offline) {
				setPay(false);
				setPayWorldline(false);
				setOffline(false);
			} else {
				setPay(false);
				setPayWorldline(false);
				setOffline(true);
			}
		}

		console.log(e.target.value);
	};
	const edit = () => {
		history.push({
			pathname: '/summaryflight',
			state: {
				formData: location.state.formData,
				body: location.state.body,
				OneflightData: location.state.OneflightData,
				IDTBO: location.state.IDTBO,
				IDEtrav: location.state.IDEtrav,
				orderID: location.state.orderID,
			},
		});
	};
	const adult = location.state.body
		? location.state.body.AdultCount
		: location.state.returnBody.AdultCount;
	const child = location.state.body
		? location.state.body.ChildCount
		: location.state.returnBody.ChildCount;
	const infant = location.state.body
		? location.state.body.InfantCount
		: location.state.returnBody.InfantCount;
	const ar = [];
	const ar2 = [];
	const ar3 = [];
	for (let i = 1; i <= adult; i++) {
		ar.push({});
	}
	for (let i = 1; i <= child; i++) {
		ar2.push({});
	}
	for (let i = 1; i <= infant; i++) {
		ar3.push({});
	}
	return (
		<>
			<Formik
				initialValues={{
					adults: location.state.formData.adult,
					childs: location.state.formData.child,
					infants: location.state.formData.infant,
				}}
				onSubmit={handleFormSubmit}>
				{(formik) => (
					<Form>
						<Box
							className={classes.root}
							style={{
								background: 'white',
								padding: '10px 15px',
								border: '1px solid #e6e6e6',
								marginTop: '10px',
								boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
								borderRadius: '5px',
							}}>
							<Grid
								container
								spacing={2}
								alignItems='center'
								style={{ marginTop: 20, alignItems: 'baseline' }}>
								<Grid item xs={12} lg={6}>
									<Field
										component={TextField}
										name='email'
										type='email'
										disabled
										variant='outlined'
										value={location.state.formData.email}
										// error={errors.email}
										// label='Email ID'
										className={classes.selectField}
										InputProps={{
											className: classes.InputPropsStyle,
										}}
										inputProps={{
											style: { padding: 12 },
										}}
									/>
								</Grid>
								<Grid item xs={12} lg={6}>
									<Field
										component={TextField}
										name='phone'
										disabled
										type='number'
										value={location.state.formData.phone}
										variant='outlined'
										// error={errors.phone}
										// label='Mobile No.'
										className={classes.selectField}
										InputProps={{
											className: classes.InputPropsStyle,
										}}
										inputProps={{
											style: { padding: 12 },
										}}
									/>
								</Grid>
							</Grid>
						</Box>
						<FieldArray
							name='adult'
							render={(arrayHelpers) => {
								return (
									<div>
										{formik.values.adults.map((adult, index) => (
											<>
												<Box
													className={classes.root}
													style={{
														background: 'white',
														padding: '10px 15px',
														border: '1px solid #e6e6e6',
														marginTop: '10px',
														boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
														borderRadius: '5px',
													}}>
													<div>{`Enter the Detail of Adult.${index + 1}`}</div>

													<Grid
														container
														spacing={2}
														alignItems='center'
														style={{ marginTop: 20, alignItems: 'baseline' }}>
														<Grid
															item
															xs={12}
															sm={6}
															lg={4}
															className={classes.root2}
															style={{ alignItems: 'center' }}>
															<Field
																component={TextField}
																select
																disabled
																name={`adult.${index}.title`}
																type='text'
																variant='outlined'
																// label='Select Title'
																value={adult.title}
																// error={errors.titleA1}
																className={classes.selectField}
																InputProps={{
																	className: classes.InputPropsStyle,
																}}
																inputProps={{
																	className: classes.inputPropsStyle,
																}}>
																{title.map((item, index) => (
																	<MenuItem key={index} value={item}>
																		{item}
																	</MenuItem>
																))}
															</Field>
														</Grid>
														<Grid item xs={12} sm={6} lg={4}>
															<Field
																component={TextField}
																name={`adult.${index}.firstname`}
																type='text'
																disabled
																// error={errors.first_nameA1}
																variant='outlined'
																value={adult.firstname}
																// label='Enter First Name'
																className={classes.selectField}
																InputProps={{
																	className: classes.InputPropsStyle,
																}}
																inputProps={{
																	style: { padding: 12 },
																}}
															/>
														</Grid>
														<Grid item xs={12} sm={6} lg={4}>
															<Field
																component={TextField}
																name={`adult.${index}.lastname`}
																type='text'
																disabled
																value={adult.lastname}
																// error={errors.last_nameA1}
																variant='outlined'
																// label='Enter Last Name'
																className={classes.selectField}
																InputProps={{
																	className: classes.InputPropsStyle,
																}}
																inputProps={{
																	style: { padding: 12 },
																}}
															/>
														</Grid>
														{selectedOrigin.country_code === 'IN' &&
														selectedDepart.country_code === 'IN' ? (
															''
														) : (
															<>
																<Grid item xs={12} sm={6} lg={4}>
																	<Field
																		component={TextField}
																		name={`adult.${index}.passportnumber`}
																		type='text'
																		disabled
																		value={adult.passportnumber}
																		// error={errors.last_nameA1}
																		variant='outlined'
																		// label="Enter Passport Number"
																		className={classes.selectField}
																		InputProps={{
																			className: classes.InputPropsStyle,
																		}}
																		inputProps={{
																			style: { padding: 12 },
																		}}
																	/>
																</Grid>
																<Grid item xs={12} sm={6} lg={4}>
																	<Field
																		component={TextField}
																		name={`adult.${index}.expiry`}
																		type='date'
																		disabled
																		// error={errors.last_nameA1}
																		variant='outlined'
																		value={adult.expiry}
																		// label='Enter Passport Number'
																		className={classes.selectField}
																		InputProps={{
																			className: classes.InputPropsStyle,
																		}}
																		inputProps={{
																			style: { padding: 12 },
																		}}
																	/>
																</Grid>
																<Grid item xs={12} sm={6} lg={4}>
																	<Field
																		component={TextField}
																		name={`adult.${index}.dob`}
																		type='date'
																		disabled
																		value={adult.dob}
																		// error={errors.last_nameA1}
																		variant='outlined'
																		// label='Enter Passport Number'
																		className={classes.selectField}
																		InputProps={{
																			className: classes.InputPropsStyle,
																		}}
																		inputProps={{
																			style: { padding: 12 },
																		}}
																	/>
																</Grid>
															</>
														)}
														{/* {location.state.body && (
                              <>
                                <Grid
                                  item
                                  xs={12}
                                  sm={6}
                                  lg={12}
                                  className={classes.root2}
                                  style={{ alignItems: "center" }}
                                >
                                  <Box
                                    display="flex"
                                    justifyContent="space-between"
                                    alignItems="center"
                                  >
                                    <span style={{ width: "100%" }}>
                                      Select Excess Baggage
                                    </span>
                                    <Field
                                      component={TextField}
                                      select
                                      disabled
                                      name={`adult.${index}.baggage`}
                                      type="text"
                                      variant="outlined"
                                      label="Select Baggage"
                                      // error={errors.titleA1}
                                      className={classes.selectField}
                                      InputProps={{
                                        className: classes.InputPropsStyle,
                                      }}
                                      inputProps={{
                                        className: classes.inputPropsStyle,
                                      }}
                                    >
                                      {farequotetripjack
                                        ? farequotetripjack?.result?.tripInfos[0]?.sI[0]?.ssrInfo?.BAGGAGE?.map(
                                            (item, inde) => {
                                              return (
                                                <MenuItem
                                                  key={inde}
                                                  value={item}
                                                >
                                                  {`${item.desc} Rs ${item.amount}`}
                                                </MenuItem>
                                              );
                                            }
                                          )
                                        : ssrTBO &&
                                          ssrTBO?.result &&
                                          ssrTBO?.result.Response.Baggage[0]?.map(
                                            (item, inde) => (
                                              <MenuItem key={inde} value={item}>
                                                {`${item.Weight}kg Rs ${item.Price}`}
                                              </MenuItem>
                                            )
                                          )}
                                    </Field>
                                    {index === 0 ? (
                                      <Box
                                        style={{
                                          width: "100%",
                                          marginLeft: 20,
                                        }}
                                      >
                                        <span>
                                          {baggageAdult1?.AirlineCode
                                            ? `Baggage : ${baggageAdult1?.Weight} kg`
                                            : baggageAdult1?.desc}
                                        </span>
                                        <span>
                                          <br></br>
                                          Baggage Charges : Rs.{" "}
                                          {baggageAdult1?.AirlineCode
                                            ? baggageAdult1?.Price
                                            : baggageAdult1?.amount}
                                        </span>
                                      </Box>
                                    ) : index === 1 ? (
                                      <Box
                                        style={{
                                          width: "100%",
                                          marginLeft: 20,
                                        }}
                                      >
                                        <span>
                                          {baggageAdult2?.AirlineCode
                                            ? `Baggage : ${baggageAdult2?.Weight} kg`
                                            : baggageAdult2?.desc}
                                        </span>
                                        <span>
                                          <br></br>
                                          Baggage Charges : Rs.{" "}
                                          {baggageAdult2?.AirlineCode
                                            ? baggageAdult2?.Price
                                            : baggageAdult2?.amount}
                                        </span>
                                      </Box>
                                    ) : index === 2 ? (
                                      <Box
                                        style={{
                                          width: "100%",
                                          marginLeft: 20,
                                        }}
                                      >
                                        <span>
                                          {baggageAdult3?.AirlineCode
                                            ? `Baggage : ${baggageAdult3?.Weight} kg`
                                            : baggageAdult3?.desc}
                                        </span>
                                        <span>
                                          <br></br>
                                          Baggage Charges : Rs.{" "}
                                          {baggageAdult3?.AirlineCode
                                            ? baggageAdult3?.Price
                                            : baggageAdult3?.amount}
                                        </span>
                                      </Box>
                                    ) : index === 3 ? (
                                      <Box
                                        style={{
                                          width: "100%",
                                          marginLeft: 20,
                                        }}
                                      >
                                        <span>
                                          {baggageAdult4?.AirlineCode
                                            ? `Baggage : ${baggageAdult4?.Weight} kg`
                                            : baggageAdult4?.desc}
                                        </span>
                                        <span>
                                          <br></br>
                                          Baggage Charges : Rs.{" "}
                                          {baggageAdult4?.AirlineCode
                                            ? baggageAdult4?.Price
                                            : baggageAdult4?.amount}
                                        </span>
                                      </Box>
                                    ) : index === 4 ? (
                                      <Box
                                        style={{
                                          width: "100%",
                                          marginLeft: 20,
                                        }}
                                      >
                                        <span>
                                          {baggageAdult5?.AirlineCode
                                            ? `Baggage : ${baggageAdult5?.Weight} kg`
                                            : baggageAdult5?.desc}
                                        </span>
                                        <span>
                                          <br></br>
                                          Baggage Charges : Rs.{" "}
                                          {baggageAdult5?.AirlineCode
                                            ? baggageAdult5?.Price
                                            : baggageAdult5?.amount}
                                        </span>
                                      </Box>
                                    ) : index === 5 ? (
                                      <Box
                                        style={{
                                          width: "100%",
                                          marginLeft: 20,
                                        }}
                                      >
                                        <span>
                                          {baggageAdult6?.AirlineCode
                                            ? `Baggage : ${baggageAdult6?.Weight} kg`
                                            : baggageAdult6?.desc}
                                        </span>
                                        <span>
                                          <br></br>
                                          Baggage Charges : Rs.{" "}
                                          {baggageAdult6?.AirlineCode
                                            ? baggageAdult6?.Price
                                            : baggageAdult6?.amount}
                                        </span>
                                      </Box>
                                    ) : index === 6 ? (
                                      <Box
                                        style={{
                                          width: "100%",
                                          marginLeft: 20,
                                        }}
                                      >
                                        <span>
                                          {baggageAdult7?.AirlineCode
                                            ? `Baggage : ${baggageAdult7?.Weight} kg`
                                            : baggageAdult7?.desc}
                                        </span>
                                        <span>
                                          <br></br>
                                          Baggage Charges : Rs.{" "}
                                          {baggageAdult7?.AirlineCode
                                            ? baggageAdult7?.Price
                                            : baggageAdult7?.amount}
                                        </span>
                                      </Box>
                                    ) : index === 7 ? (
                                      <Box
                                        style={{
                                          width: "100%",
                                          marginLeft: 20,
                                        }}
                                      >
                                        <span>
                                          {baggageAdult8?.AirlineCode
                                            ? `Baggage : ${baggageAdult8?.Weight} kg`
                                            : baggageAdult8?.desc}
                                        </span>
                                        <span>
                                          <br></br>
                                          Baggage Charges : Rs.{" "}
                                          {baggageAdult8?.AirlineCode
                                            ? baggageAdult8?.Price
                                            : baggageAdult8?.amount}
                                        </span>
                                      </Box>
                                    ) : index === 8 ? (
                                      <Box
                                        style={{
                                          width: "100%",
                                          marginLeft: 20,
                                        }}
                                      >
                                        <span>
                                          {baggageAdult9?.AirlineCode
                                            ? `Baggage : ${baggageAdult9?.Weight} kg`
                                            : baggageAdult9?.desc}
                                        </span>
                                        <span>
                                          <br></br>
                                          Baggage Charges : Rs.{" "}
                                          {baggageAdult9?.AirlineCode
                                            ? baggageAdult9?.Price
                                            : baggageAdult9?.amount}
                                        </span>
                                      </Box>
                                    ) : (
                                      ""
                                    )}
                                  </Box>
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  sm={6}
                                  lg={12}
                                  className={classes.root2}
                                  style={{ alignItems: "center" }}
                                >
                                  <Box
                                    display="flex"
                                    justifyContent="space-between"
                                    alignItems="center"
                                  >
                                    <span style={{ width: "100%" }}>
                                      Select Meal Preferences
                                    </span>
                                    <Field
                                      component={TextField}
                                      select
                                      name={`adult.${index}.baggage`}
                                      type="text"
                                      variant="outlined"
                                      label="Select Meal"
                                      disabled
                                      // error={errors.titleA1}
                                      className={classes.selectField}
                                      InputProps={{
                                        className: classes.InputPropsStyle,
                                      }}
                                      inputProps={{
                                        className: classes.inputPropsStyle,
                                      }}
                                    >
                                      {farequotetripjack
                                        ? farequotetripjack?.result?.tripInfos[0]?.sI[0]?.ssrInfo?.MEAL?.map(
                                            (item, inde) => {
                                              return (
                                                <MenuItem
                                                  key={inde}
                                                  value={item}
                                                >
                                                  {`${item.desc} Rs ${item.amount}`}
                                                </MenuItem>
                                              );
                                            }
                                          )
                                        : ssrTBO &&
                                          ssrTBO?.result &&
                                          ssrTBO?.result.Response.MealDynamic[0]?.map(
                                            (item, inde) => (
                                              <MenuItem key={inde} value={item}>
                                                {`${item.AirlineDescription}kg Rs ${item.Price}`}
                                              </MenuItem>
                                            )
                                          )}
                                    </Field>
                                    {index === 0 ? (
                                      <Box
                                        style={{
                                          width: "100%",
                                          marginLeft: 20,
                                        }}
                                      >
                                        <span>
                                          {mealAdult1?.AirlineCode
                                            ? `Meal : ${mealAdult1?.AirlineDescription} `
                                            : mealAdult1?.desc}
                                        </span>
                                        <span>
                                          <br></br>
                                          Meal Charges : Rs.{" "}
                                          {mealAdult1?.AirlineCode
                                            ? mealAdult1?.Price
                                            : mealAdult1?.amount}
                                        </span>
                                      </Box>
                                    ) : index === 1 ? (
                                      <Box
                                        style={{
                                          width: "100%",
                                          marginLeft: 20,
                                        }}
                                      >
                                        <span>
                                          {mealAdult2?.AirlineCode
                                            ? `Meal : ${mealAdult2?.AirlineDescription}`
                                            : mealAdult2?.desc}
                                        </span>
                                        <span>
                                          <br></br>
                                          Meal Charges : Rs.{" "}
                                          {mealAdult2?.AirlineCode
                                            ? mealAdult2?.Price
                                            : mealAdult2?.amount}
                                        </span>
                                      </Box>
                                    ) : index === 2 ? (
                                      <Box
                                        style={{
                                          width: "100%",
                                          marginLeft: 20,
                                        }}
                                      >
                                        <span>
                                          {mealAdult3?.AirlineCode
                                            ? `Meal : ${mealAdult3?.AirlineDescription} `
                                            : mealAdult3?.desc}
                                        </span>
                                        <span>
                                          <br></br>
                                          Meal Charges : Rs.{" "}
                                          {mealAdult3?.AirlineCode
                                            ? mealAdult3?.Price
                                            : mealAdult3?.amount}
                                        </span>
                                      </Box>
                                    ) : index === 3 ? (
                                      <Box
                                        style={{
                                          width: "100%",
                                          marginLeft: 20,
                                        }}
                                      >
                                        <span>
                                          {mealAdult4?.AirlineCode
                                            ? `Meal : ${mealAdult4?.AirlineDescription} `
                                            : mealAdult4?.desc}
                                        </span>
                                        <span>
                                          <br></br>
                                          Meal Charges : Rs.{" "}
                                          {mealAdult4?.AirlineCode
                                            ? mealAdult4?.Price
                                            : mealAdult4?.amount}
                                        </span>
                                      </Box>
                                    ) : index === 4 ? (
                                      <Box
                                        style={{
                                          width: "100%",
                                          marginLeft: 20,
                                        }}
                                      >
                                        <span>
                                          {mealAdult5?.AirlineCode
                                            ? `Meal : ${mealAdult5?.AirlineDescription} `
                                            : mealAdult5?.desc}
                                        </span>
                                        <span>
                                          <br></br>
                                          Meal Charges : Rs.{" "}
                                          {mealAdult5?.AirlineCode
                                            ? mealAdult5?.Price
                                            : mealAdult5?.amount}
                                        </span>
                                      </Box>
                                    ) : index === 5 ? (
                                      <Box
                                        style={{
                                          width: "100%",
                                          marginLeft: 20,
                                        }}
                                      >
                                        <span>
                                          {mealAdult6?.AirlineCode
                                            ? `Meal : ${mealAdult6?.AirlineDescription}`
                                            : mealAdult6?.desc}
                                        </span>
                                        <span>
                                          <br></br>
                                          Meal Charges : Rs.{" "}
                                          {mealAdult6?.AirlineCode
                                            ? mealAdult6?.Price
                                            : mealAdult6?.amount}
                                        </span>
                                      </Box>
                                    ) : index === 6 ? (
                                      <Box
                                        style={{
                                          width: "100%",
                                          marginLeft: 20,
                                        }}
                                      >
                                        <span>
                                          {mealAdult7?.AirlineCode
                                            ? `Meal : ${mealAdult7?.AirlineDescription} `
                                            : mealAdult7?.desc}
                                        </span>
                                        <span>
                                          <br></br>
                                          Meal Charges : Rs.{" "}
                                          {mealAdult7?.AirlineCode
                                            ? mealAdult7?.Price
                                            : mealAdult7?.amount}
                                        </span>
                                      </Box>
                                    ) : index === 7 ? (
                                      <Box
                                        style={{
                                          width: "100%",
                                          marginLeft: 20,
                                        }}
                                      >
                                        <span>
                                          {mealAdult8?.AirlineCode
                                            ? `Meal : ${mealAdult8?.AirlineDescription}`
                                            : mealAdult8?.desc}
                                        </span>
                                        <span>
                                          <br></br>
                                          Meal Charges : Rs.{" "}
                                          {mealAdult8?.AirlineCode
                                            ? mealAdult8?.Price
                                            : mealAdult8?.amount}
                                        </span>
                                      </Box>
                                    ) : index === 8 ? (
                                      <Box
                                        style={{
                                          width: "100%",
                                          marginLeft: 20,
                                        }}
                                      >
                                        <span>
                                          {mealAdult9?.AirlineCode
                                            ? `Meal : ${mealAdult9?.AirlineDescription}`
                                            : mealAdult9?.desc}
                                        </span>
                                        <span>
                                          <br></br>
                                          Meal Charges : Rs.{" "}
                                          {mealAdult9?.AirlineCode
                                            ? mealAdult9?.Price
                                            : mealAdult9?.amount}
                                        </span>
                                      </Box>
                                    ) : (
                                      ""
                                    )}
                                  </Box>
                                </Grid>
                              </>
                            )} */}
													</Grid>
												</Box>
											</>
										))}
										{/* <div onClick={() => arrayHelpers.insert()}>
											<h2>Add</h2>
										</div> */}
									</div>
								);
							}}
						/>
						<FieldArray
							name='child'
							render={(arrayHelpers) => {
								return (
									<div>
										{formik.values.childs?.map((child, index) => (
											<>
												<Box
													className={classes.root}
													style={{
														background: 'white',
														padding: '10px 15px',
														border: '1px solid #e6e6e6',
														marginTop: '10px',
														boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
														borderRadius: '5px',
													}}>
													<div>{`Enter the Detail of Child.${index + 1}`}</div>
													{/* <Field
														disabled
														type='text'
														name={`chil.${index}.firsName`}
														value={chil.firsName}
													/>
													<Field type='date' name={`chil.${index}.date`} /> */}
													<Grid
														container
														spacing={2}
														alignItems='center'
														style={{ marginTop: 20, alignItems: 'baseline' }}>
														<Grid
															item
															xs={12}
															sm={6}
															lg={3}
															className={classes.root2}
															style={{ alignItems: 'center' }}>
															<Field
																component={TextField}
																select
																name={`child.${index}.title`}
																type='text'
																value={child.title}
																variant='outlined'
																disabled
																// label='Select Title'
																// error={errors.titleC1}
																className={classes.selectField}
																InputProps={{
																	className: classes.InputPropsStyle,
																}}
																inputProps={{
																	className: classes.inputPropsStyle,
																}}>
																{titleC.map((item, index) => (
																	<MenuItem key={index} value={item}>
																		{item}
																	</MenuItem>
																))}
															</Field>
														</Grid>
														<Grid item xs={12} sm={6} lg={3}>
															<Field
																component={TextField}
																name={`child.${index}.firstname`}
																type='text'
																value={child.firstname}
																variant='outlined'
																disabled
																// error={errors.first_nameC1}
																// label='Enter First Name'
																className={classes.selectField}
																InputProps={{
																	className: classes.InputPropsStyle,
																}}
																inputProps={{
																	style: { padding: 12 },
																}}
															/>
														</Grid>
														<Grid item xs={12} sm={6} lg={3}>
															<Field
																component={TextField}
																name={`child.${index}.lastname`}
																type='text'
																value={child.lastname}
																variant='outlined'
																disabled
																// error={errors.last_nameC1}
																// label='Enter Last Name'
																className={classes.selectField}
																InputProps={{
																	className: classes.InputPropsStyle,
																}}
																inputProps={{
																	style: { padding: 12 },
																}}
															/>
														</Grid>
														<Grid item xs={12} sm={6} lg={3}>
															<Field
																component={TextField}
																name={`child.${index}.dob`}
																type='date'
																value={child.dob}
																variant='outlined'
																disabled
																// error={errors.last_nameC1}
																// label='Enter Last Name'
																className={classes.selectField}
																InputProps={{
																	className: classes.InputPropsStyle,
																}}
																inputProps={{
																	style: { padding: 12 },
																}}
															/>
														</Grid>
														{selectedOrigin.country_code === 'IN' &&
														selectedDepart.country_code === 'IN' ? (
															''
														) : (
															<>
																<Grid item xs={12} sm={6} lg={4}>
																	<Field
																		component={TextField}
																		name={`child.${index}.passportnumber`}
																		type='text'
																		// error={errors.last_nameA1}
																		variant='outlined'
																		disabled
																		value={child.passportnumber}
																		// label="Enter Passport Number"
																		className={classes.selectField}
																		InputProps={{
																			className: classes.InputPropsStyle,
																		}}
																		inputProps={{
																			style: { padding: 12 },
																		}}
																	/>
																</Grid>
																<Grid item xs={12} sm={6} lg={4}>
																	<Field
																		component={TextField}
																		name={`child.${index}.expiry`}
																		type='date'
																		disabled
																		value={child.expiry}
																		// error={errors.last_nameA1}
																		variant='outlined'
																		// label='Enter Passport Number'
																		className={classes.selectField}
																		InputProps={{
																			className: classes.InputPropsStyle,
																		}}
																		inputProps={{
																			style: { padding: 12 },
																		}}
																	/>
																</Grid>
															</>
														)}
														{/* {location.state.body && (
                              <>
                                <Grid
                                  item
                                  xs={12}
                                  sm={6}
                                  lg={12}
                                  className={classes.root2}
                                  style={{ alignItems: "center" }}
                                >
                                  <Box
                                    display="flex"
                                    justifyContent="space-between"
                                    alignItems="center"
                                  >
                                    <span style={{ width: "100%" }}>
                                      Select Excess Baggage
                                    </span>
                                    <Field
                                      component={TextField}
                                      select
                                      name={`child.${index}.baggage`}
                                      type="text"
                                      variant="outlined"
                                      label="Select Baggage"
                                      disabled
                                      // error={errors.titleA1}
                                      className={classes.selectField}
                                      InputProps={{
                                        className: classes.InputPropsStyle,
                                      }}
                                      inputProps={{
                                        className: classes.inputPropsStyle,
                                      }}
                                    >
                                      {farequotetripjack
                                        ? farequotetripjack?.result?.tripInfos[0]?.sI[0]?.ssrInfo?.BAGGAGE?.map(
                                            (item, inde) => {
                                              return (
                                                <MenuItem
                                                  key={inde}
                                                  value={item}
                                                >
                                                  {`${item.desc} Rs ${item.amount}`}
                                                </MenuItem>
                                              );
                                            }
                                          )
                                        : ssrTBO &&
                                          ssrTBO?.result &&
                                          ssrTBO?.result.Response.Baggage[0]?.map(
                                            (item, inde) => (
                                              <MenuItem key={inde} value={item}>
                                                {`${item.Weight}kg Rs ${item.Price}`}
                                              </MenuItem>
                                            )
                                          )}
                                    </Field>
                                    {index === 0 ? (
                                      <Box
                                        style={{
                                          width: "100%",
                                          marginLeft: 20,
                                        }}
                                      >
                                        <span>
                                          {baggageChild1?.AirlineCode
                                            ? `Baggage : ${baggageChild1?.Weight} kg`
                                            : baggageChild1?.desc}
                                        </span>
                                        <span>
                                          <br></br>
                                          Baggage Charges : Rs.{" "}
                                          {baggageChild1?.AirlineCode
                                            ? baggageChild1?.Price
                                            : baggageChild1?.amount}
                                        </span>
                                      </Box>
                                    ) : index === 1 ? (
                                      <Box
                                        style={{
                                          width: "100%",
                                          marginLeft: 20,
                                        }}
                                      >
                                        <span>
                                          {baggageChild2?.AirlineCode
                                            ? `Baggage : ${baggageChild2?.Weight} kg`
                                            : baggageChild2?.desc}
                                        </span>
                                        <span>
                                          <br></br>
                                          Baggage Charges : Rs.{" "}
                                          {baggageChild2?.AirlineCode
                                            ? baggageChild2?.Price
                                            : baggageChild2?.amount}
                                        </span>
                                      </Box>
                                    ) : index === 2 ? (
                                      <Box
                                        style={{
                                          width: "100%",
                                          marginLeft: 20,
                                        }}
                                      >
                                        <span>
                                          {baggageChild3?.AirlineCode
                                            ? `Baggage : ${baggageChild3?.Weight} kg`
                                            : baggageChild3?.desc}
                                        </span>
                                        <span>
                                          <br></br>
                                          Baggage Charges : Rs.{" "}
                                          {baggageChild3?.AirlineCode
                                            ? baggageChild3?.Price
                                            : baggageChild3?.amount}
                                        </span>
                                      </Box>
                                    ) : index === 3 ? (
                                      <Box
                                        style={{
                                          width: "100%",
                                          marginLeft: 20,
                                        }}
                                      >
                                        <span>
                                          {baggageChild4?.AirlineCode
                                            ? `Baggage : ${baggageChild4?.Weight} kg`
                                            : baggageChild4?.desc}
                                        </span>
                                        <span>
                                          <br></br>
                                          Baggage Charges : Rs.{" "}
                                          {baggageChild4?.AirlineCode
                                            ? baggageChild4?.Price
                                            : baggageChild4?.amount}
                                        </span>
                                      </Box>
                                    ) : index === 4 ? (
                                      <Box
                                        style={{
                                          width: "100%",
                                          marginLeft: 20,
                                        }}
                                      >
                                        <span>
                                          {baggageChild5?.AirlineCode
                                            ? `Baggage : ${baggageChild5?.Weight} kg`
                                            : baggageChild5?.desc}
                                        </span>
                                        <span>
                                          <br></br>
                                          Baggage Charges : Rs.{" "}
                                          {baggageChild5?.AirlineCode
                                            ? baggageChild5?.Price
                                            : baggageChild5?.amount}
                                        </span>
                                      </Box>
                                    ) : index === 5 ? (
                                      <Box
                                        style={{
                                          width: "100%",
                                          marginLeft: 20,
                                        }}
                                      >
                                        <span>
                                          {baggageChild6?.AirlineCode
                                            ? `Baggage : ${baggageChild6?.Weight} kg`
                                            : baggageChild6?.desc}
                                        </span>
                                        <span>
                                          <br></br>
                                          Baggage Charges : Rs.{" "}
                                          {baggageChild6?.AirlineCode
                                            ? baggageChild6?.Price
                                            : baggageChild6?.amount}
                                        </span>
                                      </Box>
                                    ) : (
                                      ""
                                    )}
                                  </Box>
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  sm={6}
                                  lg={12}
                                  className={classes.root2}
                                  style={{ alignItems: "center" }}
                                >
                                  <Box
                                    display="flex"
                                    justifyContent="space-between"
                                    alignItems="center"
                                  >
                                    <span style={{ width: "100%" }}>
                                      Select Meal Preferences
                                    </span>
                                    <Field
                                      component={TextField}
                                      select
                                      name={`child.${index}.meal`}
                                      type="text"
                                      variant="outlined"
                                      label="Select Meal"
                                      disabled
                                      // error={errors.titleA1}
                                      className={classes.selectField}
                                      InputProps={{
                                        className: classes.InputPropsStyle,
                                      }}
                                      inputProps={{
                                        className: classes.inputPropsStyle,
                                      }}
                                    >
                                      {farequotetripjack
                                        ? farequotetripjack?.result?.tripInfos[0]?.sI[0]?.ssrInfo?.MEAL?.map(
                                            (item, inde) => {
                                              return (
                                                <MenuItem
                                                  key={inde}
                                                  value={item}
                                                >
                                                  {`${item.AirlineDescription}kg Rs ${item.Price}`}
                                                </MenuItem>
                                              );
                                            }
                                          )
                                        : ssrTBO &&
                                          ssrTBO?.result &&
                                          ssrTBO?.result.Response.MealDynamic[0]?.map(
                                            (item, inde) => (
                                              <MenuItem key={inde} value={item}>
                                                {`${item.Weight}kg Rs ${item.Price}`}
                                              </MenuItem>
                                            )
                                          )}
                                    </Field>
                                    {index === 0 ? (
                                      <Box
                                        style={{
                                          width: "100%",
                                          marginLeft: 20,
                                        }}
                                      >
                                        <span>
                                          {mealChild1?.AirlineCode
                                            ? `Meal : ${mealChild1?.AirlineDescription}`
                                            : mealChild1?.desc}
                                        </span>
                                        <span>
                                          <br></br>
                                          Meal Charges : Rs.{" "}
                                          {mealChild1?.AirlineCode
                                            ? mealChild1?.Price
                                            : mealChild1?.amount}
                                        </span>
                                      </Box>
                                    ) : index === 1 ? (
                                      <Box
                                        style={{
                                          width: "100%",
                                          marginLeft: 20,
                                        }}
                                      >
                                        <span>
                                          {mealChild2?.AirlineCode
                                            ? `Meal : ${mealChild2?.AirlineDescription}`
                                            : mealChild2?.desc}
                                        </span>
                                        <span>
                                          <br></br>
                                          Meal Charges : Rs.{" "}
                                          {mealChild2?.AirlineCode
                                            ? mealChild2?.Price
                                            : mealChild2?.amount}
                                        </span>
                                      </Box>
                                    ) : index === 2 ? (
                                      <Box
                                        style={{
                                          width: "100%",
                                          marginLeft: 20,
                                        }}
                                      >
                                        <span>
                                          {mealChild3?.AirlineCode
                                            ? `Meal : ${mealChild3?.AirlineDescription}`
                                            : mealChild3?.desc}
                                        </span>
                                        <span>
                                          <br></br>
                                          Meal Charges : Rs.{" "}
                                          {mealChild3?.AirlineCode
                                            ? mealChild3?.Price
                                            : mealChild3?.amount}
                                        </span>
                                      </Box>
                                    ) : index === 3 ? (
                                      <Box
                                        style={{
                                          width: "100%",
                                          marginLeft: 20,
                                        }}
                                      >
                                        <span>
                                          {mealChild4?.AirlineCode
                                            ? `Meal : ${mealChild4?.AirlineDescription}`
                                            : mealChild4?.desc}
                                        </span>
                                        <span>
                                          <br></br>
                                          Meal Charges : Rs.{" "}
                                          {mealChild4?.AirlineCode
                                            ? mealChild4?.Price
                                            : mealChild4?.amount}
                                        </span>
                                      </Box>
                                    ) : index === 4 ? (
                                      <Box
                                        style={{
                                          width: "100%",
                                          marginLeft: 20,
                                        }}
                                      >
                                        <span>
                                          {mealChild5?.AirlineCode
                                            ? `Meal : ${mealChild5?.AirlineDescription}`
                                            : mealChild5?.desc}
                                        </span>
                                        <span>
                                          <br></br>
                                          Meal Charges : Rs.{" "}
                                          {mealChild5?.AirlineCode
                                            ? mealChild5?.Price
                                            : mealChild5?.amount}
                                        </span>
                                      </Box>
                                    ) : index === 5 ? (
                                      <Box
                                        style={{
                                          width: "100%",
                                          marginLeft: 20,
                                        }}
                                      >
                                        <span>
                                          {mealChild6?.AirlineCode
                                            ? `Meal : ${mealChild6?.AirlineDescription}`
                                            : mealChild6?.desc}
                                        </span>
                                        <span>
                                          <br></br>
                                          Meal Charges : Rs.{" "}
                                          {mealChild6?.AirlineCode
                                            ? mealChild6?.Price
                                            : mealChild6?.amount}
                                        </span>
                                      </Box>
                                    ) : (
                                      ""
                                    )}
                                  </Box>
                                </Grid>
                              </>
                            )} */}
													</Grid>
												</Box>
											</>
										))}
									</div>
								);
							}}
						/>
						<FieldArray
							name='infant'
							render={(arrayHelpers) => {
								return (
									<div>
										{formik.values.infants?.map((infant, index) => (
											<>
												<Box
													className={classes.root}
													style={{
														background: 'white',
														padding: '10px 15px',
														border: '1px solid #e6e6e6',
														marginTop: '10px',
														boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
														borderRadius: '5px',
													}}>
													<div>{`Enter the Detail of Infant.${index + 1}`}</div>
													{/* <Field
														disabled
														type='text'
														name={`chil.${index}.firsName`}
														value={chil.firsName}
													/>
													<Field type='date' name={`chil.${index}.date`} /> */}
													<Grid
														container
														spacing={2}
														alignItems='center'
														style={{ marginTop: 20, alignItems: 'baseline' }}>
														<Grid
															item
															xs={12}
															sm={6}
															lg={3}
															className={classes.root2}
															style={{ alignItems: 'center' }}>
															<Field
																component={TextField}
																select
																name={`infant.${index}.title`}
																type='text'
																value={infant.title}
																variant='outlined'
																disabled
																// label='Select Title'
																// error={errors.titleC1}
																className={classes.selectField}
																InputProps={{
																	className: classes.InputPropsStyle,
																}}
																inputProps={{
																	className: classes.inputPropsStyle,
																}}>
																{titleI.map((item, index) => (
																	<MenuItem key={index} value={item}>
																		{item}
																	</MenuItem>
																))}
															</Field>
														</Grid>
														<Grid item xs={12} sm={6} lg={3}>
															<Field
																component={TextField}
																name={`infant.${index}.firstname`}
																type='text'
																value={infant.firstname}
																variant='outlined'
																disabled
																// error={errors.first_nameC1}
																// label='Enter First Name'
																className={classes.selectField}
																InputProps={{
																	className: classes.InputPropsStyle,
																}}
																inputProps={{
																	style: { padding: 12 },
																}}
															/>
														</Grid>
														<Grid item xs={12} sm={6} lg={3}>
															<Field
																component={TextField}
																name={`infant.${index}.lastname`}
																type='text'
																value={infant.lastname}
																variant='outlined'
																disabled
																// error={errors.last_nameC1}
																// label='Enter Last Name'
																className={classes.selectField}
																InputProps={{
																	className: classes.InputPropsStyle,
																}}
																inputProps={{
																	style: { padding: 12 },
																}}
															/>
														</Grid>
														<Grid item xs={12} sm={6} lg={3}>
															<Field
																component={TextField}
																name={`infant.${index}.dob`}
																type='date'
																value={infant.dob}
																variant='outlined'
																disabled
																// error={errors.last_nameC1}
																// label='Enter Last Name'
																className={classes.selectField}
																InputProps={{
																	className: classes.InputPropsStyle,
																}}
																inputProps={{
																	style: { padding: 12 },
																}}
															/>
														</Grid>
														{selectedOrigin.country_code === 'IN' &&
														selectedDepart.country_code === 'IN' ? (
															''
														) : (
															<>
																<Grid item xs={12} sm={6} lg={4}>
																	<Field
																		component={TextField}
																		name={`infant.${index}.passportnumber`}
																		type='text'
																		// error={errors.last_nameA1}
																		variant='outlined'
																		disabled
																		value={infant.passportnumber}
																		// label="Enter Passport Number"
																		className={classes.selectField}
																		InputProps={{
																			className: classes.InputPropsStyle,
																		}}
																		inputProps={{
																			style: { padding: 12 },
																		}}
																	/>
																</Grid>
																<Grid item xs={12} sm={6} lg={4}>
																	<Field
																		component={TextField}
																		name={`infant.${index}.expiry`}
																		type='date'
																		value={infant.expiry}
																		disabled
																		// error={errors.last_nameA1}
																		variant='outlined'
																		// label='Enter Passport Number'
																		className={classes.selectField}
																		InputProps={{
																			className: classes.InputPropsStyle,
																		}}
																		inputProps={{
																			style: { padding: 12 },
																		}}
																	/>
																</Grid>
															</>
														)}
													</Grid>
												</Box>
											</>
										))}
									</div>
								);
							}}
						/>

						{/* payment method */}
						<Box
							alignItems='center'
							display='flex'
							style={{
								background: 'white',
								padding: '10px 15px',
								border: '1px solid #e6e6e6',
								marginTop: '10px',
								boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
								borderRadius: '5px',
							}}>
							{agentlogin &&
							agentlogin.result &&
							agentlogin.result.result &&
							agentlogin.result.result.role === 'Agent' ? (
								// <></>
								<>
									{location.state.OneflightData ? (
										// OnewayPay with Offline
										<>
											{' '}
											<FormControlLabel
												style={{ marginRight: 0 }}
												value='offline'
												control={
													<Radio
														checked={offline}
														onClick={handleHold}
														disabled={
															location.state.OneflightData.AirlineCode
																? Number(
																		Math.round(
																			fareQuote
																				? fareQuote?.result?.Response?.Results
																						.Fare.Total_Amount
																				: location.state.OneflightData.Fare
																						.Total_Amount
																		)
																  ) -
																		Number(
																			Math.round(
																				fareQuote
																					? fareQuote?.result?.Response?.Results
																							.Fare.MFB_Discount
																					: location.state.OneflightData.Fare
																							.MFB_Discount
																			)
																		) <=
																  Number(
																		Math.round(
																			walletagent &&
																				walletagent.result.balanceAmount
																		)
																  )
																	? false
																	: true
																: location.state.OneflightData.Airline_Code
																? Number(
																		Math.round(
																			location.state.OneflightData.Fares
																				.Total_Amount
																		)
																  ) <=
																  Number(
																		Math.round(
																			walletagent &&
																				walletagent.result.balanceAmount
																		)
																  )
																	? false
																	: true
																: ''
														}
													/>
												}
											/>
											<span
												style={{
													opacity: location.state.OneflightData.AirlineCode
														? Number(
																Math.round(
																	fareQuote
																		? fareQuote?.result?.Response?.Results.Fare
																				.Total_Amount
																		: location.state.OneflightData.Fare
																				.Total_Amount
																)
														  ) -
																Number(
																	Math.round(
																		fareQuote
																			? fareQuote?.result?.Response?.Results
																					.Fare.MFB_Discount
																			: location.state.OneflightData.Fare
																					.MFB_Discount
																	)
																) <=
														  Number(
																Math.round(
																	walletagent &&
																		walletagent.result.balanceAmount
																)
														  )
															? ''
															: 0.3
														: location.state.OneflightData.Airline_Code
														? Number(
																Math.round(
																	fareQuote
																		? fareQuote?.result?.Response?.Results.Fare
																				.Total_Amount
																		: location.state.OneflightData.Fare
																				.Total_Amount
																)
														  ) -
																Number(
																	Math.round(
																		fareQuote
																			? fareQuote?.result?.Response?.Results
																					.Fare.MFB_Discount
																			: location.state.OneflightData.Fare
																					.MFB_Discount
																	)
																) <=
														  Number(
																Math.round(
																	walletagent &&
																		walletagent.result.balanceAmount
																)
														  )
															? ''
															: 0.3
														: '',
												}}>
												Offline Amount
											</span>
											<span
												style={{
													marginLeft: 5,
													color: 'blue',
													opacity: location.state.OneflightData.AirlineCode
														? Number(
																Math.round(
																	fareQuote
																		? fareQuote?.result?.Response?.Results.Fare
																				.Total_Amount
																		: location.state.OneflightData.Fare
																				.Total_Amount
																)
														  ) -
																Number(
																	Math.round(
																		fareQuote
																			? fareQuote?.result?.Response?.Results
																					.Fare.MFB_Discount
																			: location.state.OneflightData.Fare
																					.MFB_Discount
																	)
																) <=
														  Number(
																Math.round(
																	walletagent &&
																		walletagent.result.balanceAmount
																)
														  )
															? ''
															: 0.3
														: location.state.OneflightData.Airline_Code
														? Number(
																Math.round(
																	location.state.OneflightData.Fares
																		.Total_Amount
																)
														  ) <=
														  Number(
																Math.round(
																	walletagent &&
																		walletagent.result.balanceAmount
																)
														  )
															? ''
															: 0.3
														: '',
												}}>
												<span style={{ marginRight: 5, marginLeft: 5 }}>
													{'₹'}
												</span>
												{location.state.OneflightData.AirlineCode
													? Number(
															Math.round(
																fareQuote
																	? fareQuote?.result?.Response?.Results.Fare
																			.Total_Amount
																	: location.state.OneflightData.Fare
																			.Total_Amount
															)
													  ) -
													  Number(
															Math.round(
																fareQuote
																	? fareQuote?.result?.Response?.Results.Fare
																			.MFB_Discount
																	: location.state.OneflightData.Fare
																			.MFB_Discount
															)
													  )
													: location.state.OneflightData.Airline_Code
													? Number(
															Math.round(
																fareQuoteEtrav
																	? fareQuoteEtrav?.result
																			?.AirRepriceResponses[0].Flight.Fares
																			.Total_Amount
																	: location.state.OneflightData.Fares
																			.Total_Amount
															)
													  )
													: ''}
											</span>
										</>
									) : (
										// RoundtripPay with Offline
										<>
											<FormControlLabel
												style={{ marginRight: 0 }}
												value='offline'
												control={
													<Radio
														checked={offline}
														onClick={handleHold}
														disabled={
															etrav2
																? Number(
																		Number(
																			Math.round(
																				fareQuoteEtrav
																					? fareQuoteEtrav?.result
																							?.AirRepriceResponses[1].Flight
																							.Fares.Total_Amount
																					: location.state.selectedReturn[0]
																							.Fares.Total_Amount
																			)
																		) +
																			Number(
																				Math.round(
																					fareQuoteEtrav
																						? fareQuoteEtrav?.result
																								?.AirRepriceResponses[0].Flight
																								.Fares.Total_Amount
																						: location.state.selectedonward[0]
																								.Fares.Total_Amount
																				)
																			)
																  ) <
																  Number(
																		Math.round(
																			walletagent &&
																				walletagent.result.balanceAmount
																		)
																  )
																	? false
																	: true
																: tbo2
																? Number(
																		Number(
																			Math.round(
																				fareQuoteReturn
																					? fareQuoteReturn?.result.Response
																							.Results.Fare.Total_Amount
																					: location.state.selectedReturn[0]
																							.Fare.Total_Amount
																			)
																		) +
																			Number(
																				Math.round(
																					fareQuote
																						? fareQuote?.result.Response.Results
																								.Fare.Total_Amount
																						: location.state.selectedonward[0]
																								.Fare.Total_Amount
																				)
																			) -
																			Number(
																				Number(
																					Math.round(
																						fareQuoteReturn
																							? fareQuoteReturn?.result.Response
																									.Results.Fare.MFB_Discount
																							: location.state.selectedReturn[0]
																									.Fare.MFB_Discount
																					)
																				) +
																					Number(
																						Math.round(
																							fareQuote
																								? fareQuote?.result.Response
																										.Results.Fare.MFB_Discount
																								: location.state
																										.selectedonward[0].Fare
																										.MFB_Discount
																						)
																					)
																			)
																  ) <
																  Number(
																		Math.round(
																			walletagent &&
																				walletagent.result.balanceAmount
																		)
																  )
																	? false
																	: true
																: etrvotbor
																? Number(
																		Number(
																			Math.round(
																				location.state.selectedReturn[0].Fare
																					.Total_Amount
																			)
																		) +
																			Number(
																				Math.round(
																					location.state.selectedonward[0].Fares
																						.Total_Amount
																				)
																			)
																  ) <
																  Number(
																		Math.round(
																			walletagent &&
																				walletagent.result.balanceAmount
																		)
																  )
																	? false
																	: true
																: etravrtboo
																? Number(
																		Number(
																			Math.round(
																				location.state.selectedReturn[0].Fares
																					.Total_Amount
																			)
																		) +
																			Number(
																				Math.round(
																					location.state.selectedonward[0].Fare
																						.Total_Amount
																				)
																			)
																  ) <
																  Number(
																		Math.round(
																			walletagent &&
																				walletagent.result.balanceAmount
																		)
																  )
																	? false
																	: true
																: location.state.intFlight
																? Number(
																		Math.round(
																			location.state.intFlight.Fare.Total_Amount
																		)
																  ) <
																  Number(
																		Math.round(
																			walletagent &&
																				walletagent.result.balanceAmount
																		)
																  )
																	? false
																	: true
																: ''
														}
													/>
												}
											/>
											<span
												style={{
													opacity: etrav2
														? Number(
																Number(
																	Math.round(
																		fareQuoteEtrav
																			? fareQuoteEtrav?.result
																					?.AirRepriceResponses[1].Flight.Fares
																					.Total_Amount
																			: location.state.selectedReturn[0].Fares
																					.Total_Amount
																	)
																) +
																	Number(
																		Math.round(
																			fareQuoteEtrav
																				? fareQuoteEtrav?.result
																						?.AirRepriceResponses[0].Flight
																						.Fares.Total_Amount
																				: location.state.selectedonward[0].Fares
																						.Total_Amount
																		)
																	)
														  ) <
														  Number(
																Math.round(
																	walletagent &&
																		walletagent.result.balanceAmount
																)
														  )
															? ''
															: 0.3
														: tbo2
														? Number(
																Number(
																	Math.round(
																		fareQuoteReturn
																			? fareQuoteReturn?.result.Response.Results
																					.Fare.Total_Amount
																			: location.state.selectedReturn[0].Fare
																					.Total_Amount
																	)
																) +
																	Number(
																		Math.round(
																			fareQuote
																				? fareQuote?.result.Response.Results
																						.Fare.Total_Amount
																				: location.state.selectedonward[0].Fare
																						.Total_Amount
																		)
																	) -
																	Number(
																		Number(
																			Math.round(
																				fareQuoteReturn
																					? fareQuoteReturn?.result.Response
																							.Results.Fare.MFB_Discount
																					: location.state.selectedReturn[0]
																							.Fare.MFB_Discount
																			)
																		) +
																			Number(
																				Math.round(
																					fareQuote
																						? fareQuote?.result.Response.Results
																								.Fare.MFB_Discount
																						: location.state.selectedonward[0]
																								.Fare.MFB_Discount
																				)
																			)
																	)
														  ) <
														  Number(
																Math.round(
																	walletagent &&
																		walletagent.result.balanceAmount
																)
														  )
															? ''
															: 0.3
														: etrvotbor
														? Number(
																Number(
																	Math.round(
																		location.state.selectedReturn[0].Fare
																			.Total_Amount
																	)
																) +
																	Number(
																		Math.round(
																			location.state.selectedonward[0].Fares
																				.Total_Amount
																		)
																	)
														  ) <
														  Number(
																Math.round(
																	walletagent &&
																		walletagent.result.balanceAmount
																)
														  )
															? ''
															: 0.3
														: etravrtboo
														? Number(
																Number(
																	Math.round(
																		location.state.selectedReturn[0].Fares
																			.Total_Amount
																	)
																) +
																	Number(
																		Math.round(
																			location.state.selectedonward[0].Fare
																				.Total_Amount
																		)
																	)
														  ) <
														  Number(
																Math.round(
																	walletagent &&
																		walletagent.result.balanceAmount
																)
														  )
															? ''
															: 0.3
														: location.state.intFlight
														? Number(
																Math.round(
																	location.state.intFlight.Fare.Total_Amount
																)
														  ) <
														  Number(
																Math.round(
																	walletagent &&
																		walletagent.result.balanceAmount
																)
														  )
															? ''
															: 0.3
														: '',
												}}>
												Offline Amount
											</span>

											<span
												style={{
													marginLeft: 5,
													opacity: etrav2
														? Number(
																Number(
																	Math.round(
																		fareQuoteEtrav
																			? fareQuoteEtrav?.result
																					?.AirRepriceResponses[1].Flight.Fares
																					.Total_Amount
																			: location.state.selectedReturn[0].Fares
																					.Total_Amount
																	)
																) +
																	Number(
																		Math.round(
																			fareQuoteEtrav
																				? fareQuoteEtrav?.result
																						?.AirRepriceResponses[0].Flight
																						.Fares.Total_Amount
																				: location.state.selectedonward[0].Fares
																						.Total_Amount
																		)
																	)
														  ) <
														  Number(
																Math.round(
																	walletagent &&
																		walletagent.result.balanceAmount
																)
														  )
															? ''
															: 0.3
														: tbo2
														? Number(
																Number(
																	Math.round(
																		fareQuoteReturn
																			? fareQuoteReturn?.result.Response.Results
																					.Fare.Total_Amount
																			: location.state.selectedReturn[0].Fare
																					.Total_Amount
																	)
																) +
																	Number(
																		Math.round(
																			fareQuote
																				? fareQuote?.result.Response.Results
																						.Fare.Total_Amount
																				: location.state.selectedonward[0].Fare
																						.Total_Amount
																		)
																	) -
																	Number(
																		Number(
																			Math.round(
																				fareQuoteReturn
																					? fareQuoteReturn?.result.Response
																							.Results.Fare.MFB_Discount
																					: location.state.selectedReturn[0]
																							.Fare.MFB_Discount
																			)
																		) +
																			Number(
																				Math.round(
																					fareQuote
																						? fareQuote?.result.Response.Results
																								.Fare.MFB_Discount
																						: location.state.selectedonward[0]
																								.Fare.MFB_Discount
																				)
																			)
																	)
														  ) <
														  Number(
																Math.round(
																	walletagent &&
																		walletagent.result.balanceAmount
																)
														  )
															? ''
															: 0.3
														: location.state.intFlight
														? Number(
																Math.round(
																	location.state.intFlight.Fare.Total_Amount
																)
														  ) <
														  Number(
																Math.round(
																	walletagent &&
																		walletagent.result.balanceAmount
																)
														  )
															? ''
															: 0.3
														: '',
												}}>
												<span style={{ marginRight: 5, marginLeft: 5 }}>
													{'₹'}
												</span>
												{etrav2
													? Number(
															Number(
																Math.round(
																	fareQuoteEtrav
																		? fareQuoteEtrav?.result
																				?.AirRepriceResponses[1].Flight.Fares
																				.Total_Amount
																		: location.state.selectedReturn[0].Fares
																				.Total_Amount
																)
															) +
																Number(
																	Math.round(
																		fareQuoteEtrav
																			? fareQuoteEtrav?.result
																					?.AirRepriceResponses[0].Flight.Fares
																					.Total_Amount
																			: location.state.selectedonward[0].Fares
																					.Total_Amount
																	)
																)
													  )
													: tbo2
													? Number(
															Number(
																Math.round(
																	fareQuoteReturn
																		? fareQuoteReturn?.result.Response.Results
																				.Fare.Total_Amount
																		: location.state.selectedReturn[0].Fare
																				.Total_Amount
																)
															) +
																Number(
																	Math.round(
																		fareQuote
																			? fareQuote?.result.Response.Results.Fare
																					.Total_Amount
																			: location.state.selectedonward[0].Fare
																					.Total_Amount
																	)
																) -
																Number(
																	Number(
																		Math.round(
																			fareQuoteReturn
																				? fareQuoteReturn?.result.Response
																						.Results.Fare.MFB_Discount
																				: location.state.selectedReturn[0].Fare
																						.MFB_Discount
																		)
																	) +
																		Number(
																			Math.round(
																				fareQuote
																					? fareQuote?.result.Response.Results
																							.Fare.MFB_Discount
																					: location.state.selectedonward[0]
																							.Fare.MFB_Discount
																			)
																		)
																)
													  )
													: etrvotbor
													? Number(
															Number(
																Math.round(
																	location.state.selectedReturn[0].Fare
																		.Total_Amount
																)
															) +
																Number(
																	Math.round(
																		location.state.selectedonward[0].Fares
																			.Total_Amount
																	)
																)
													  )
													: etravrtboo
													? Number(
															Number(
																Math.round(
																	location.state.selectedReturn[0].Fares
																		.Total_Amount
																)
															) +
																Number(
																	Math.round(
																		location.state.selectedonward[0].Fare
																			.Total_Amount
																	)
																)
													  )
													: location.state.intFlight
													? Number(
															Math.round(
																location.state.intFlight.Fare.Total_Amount
															)
													  )
													: ''}
											</span>
										</>
									)}
									{/* <FormControlLabel
											style={{ marginRight: 0, marginLeft: 10 }}
											value='hold'
											control={
												<Radio
													checked={hold}
													onClick={handleHold}
													style={{ marginLeft: 10 }}
												/>
											}
											// label='Hold'
										/>
										<span>Hold</span> */}
								</>
							) : (
								''
							)}

							<FormControlLabel
								style={{ marginRight: 0, marginLeft: 10 }}
								value='pay'
								control={
									<Radio
										checked={pay}
										onClick={handleHold}
										style={{ marginLeft: 10 }}
									/>
								}
								// label='Pay Online'
							/>
							<span>Pay With Razorpay</span>
							<span style={{ marginRight: 5, marginLeft: 5 }}>{'₹'}</span>
							<span style={{ marginLeft: 5, color: 'blue' }}>
								{location.state.OneflightData
									? location.state.OneflightData.Supplier === 'ETR'
										? Number(
												Math.round(
													Number(
														Number(
															Math.round(
																fareQuoteEtrav
																	? fareQuoteEtrav?.result
																			?.AirRepriceResponses[0].Flight.Fares
																			.Total_Amount
																	: location.state.OneflightData.Fares
																			.Total_Amount
															)
														) +
															Number(
																Math.round(
																	(Number(
																		Number(
																			Math.round(
																				fareQuoteEtrav
																					? fareQuoteEtrav?.result
																							?.AirRepriceResponses[0].Flight
																							.Fares.Total_Amount
																					: location.state.OneflightData.Fares
																							.Total_Amount
																			)
																		)
																	) *
																		2.5) /
																		100
																)
															)
													)
												)
										  )
										: location.state.OneflightData.Supplier === 'TBO'
										? Number(
												Math.round(
													Number(
														Number(
															Math.round(
																fareQuote
																	? fareQuote?.result?.Response?.Results.Fare
																			.Total_Amount
																	: location.state.OneflightData.Fare
																			.Total_Amount
															)
														) -
															Number(
																Math.round(
																	fareQuote
																		? fareQuote?.result?.Response?.Results.Fare
																				.MFB_Discount
																		: location.state.OneflightData.Fare
																				.MFB_Discount
																)
															) +
															Number(
																Math.round(
																	(Number(
																		Number(
																			Math.round(
																				fareQuote
																					? fareQuote?.result?.Response?.Results
																							.Fare.Total_Amount
																					: location.state.OneflightData.Fare
																							.Total_Amount
																			)
																		) -
																			Number(
																				Math.round(
																					fareQuote
																						? fareQuote?.result?.Response
																								?.Results.Fare.MFB_Discount
																						: location.state.OneflightData.Fare
																								.MFB_Discount
																				)
																			)
																	) *
																		2.5) /
																		100
																)
															)
													)
												)
										  )
										: location.state.OneflightData.Supplier === 'TJK'
										? Number(
												Math.round(
													Number(
														Number(
															Math.round(
																location.state.OneflightData.totalPriceList.fd
																	.Total_Amount
															)
														) -
															Number(
																Math.round(
																	location.state.OneflightData.totalPriceList.fd
																		.agentMarkup
																)
															) +
															Number(
																Math.round(
																	(Number(
																		Number(
																			Math.round(
																				location.state.OneflightData
																					.totalPriceList.fd.Total_Amount
																			)
																		) -
																			Number(
																				Math.round(
																					location.state.OneflightData
																						.totalPriceList.fd.agentMarkup
																				)
																			)
																	) *
																		2.5) /
																		100
																)
															) +
															Number(
																Math.round(
																	baggageAdult1?.AirlineCode
																		? baggageAdult1?.Price
																		: baggageAdult1?.code
																		? baggageAdult1?.amount
																		: 0
																)
															) +
															Number(
																Math.round(
																	baggageAdult2?.AirlineCode
																		? baggageAdult2?.Price
																		: baggageAdult2?.code
																		? baggageAdult2?.amount
																		: 0
																)
															) +
															Number(
																Math.round(
																	baggageAdult3?.AirlineCode
																		? baggageAdult3?.Price
																		: baggageAdult3?.code
																		? baggageAdult3?.amount
																		: 0
																)
															) +
															Number(
																Math.round(
																	baggageAdult4?.AirlineCode
																		? baggageAdult4?.Price
																		: baggageAdult4?.code
																		? baggageAdult4?.amount
																		: 0
																)
															) +
															Number(
																Math.round(
																	baggageAdult5?.AirlineCode
																		? baggageAdult5?.Price
																		: baggageAdult5?.code
																		? baggageAdult5?.amount
																		: 0
																)
															) +
															Number(
																Math.round(
																	baggageAdult6?.AirlineCode
																		? baggageAdult6?.Price
																		: baggageAdult6?.code
																		? baggageAdult6?.amount
																		: 0
																)
															) +
															Number(
																Math.round(
																	baggageAdult7?.AirlineCode
																		? baggageAdult7?.Price
																		: baggageAdult7?.code
																		? baggageAdult7?.amount
																		: 0
																)
															) +
															Number(
																Math.round(
																	baggageAdult8?.AirlineCode
																		? baggageAdult8?.Price
																		: baggageAdult8?.code
																		? baggageAdult8?.amount
																		: 0
																)
															) +
															Number(
																Math.round(
																	baggageAdult9?.AirlineCode
																		? baggageAdult9?.Price
																		: baggageAdult9?.code
																		? baggageAdult9?.amount
																		: 0
																)
															) +
															Number(
																Math.round(
																	baggageChild1?.AirlineCode
																		? baggageChild1?.Price
																		: baggageChild1?.code
																		? baggageChild1?.amount
																		: 0
																)
															) +
															Number(
																Math.round(
																	baggageChild2?.AirlineCode
																		? baggageChild2?.Price
																		: baggageChild2?.code
																		? baggageChild2?.amount
																		: 0
																)
															) +
															Number(
																Math.round(
																	baggageChild3?.AirlineCode
																		? baggageChild3?.Price
																		: baggageChild3?.code
																		? baggageChild3?.amount
																		: 0
																)
															) +
															Number(
																Math.round(
																	baggageChild4?.AirlineCode
																		? baggageChild4?.Price
																		: baggageChild4?.code
																		? baggageChild4?.amount
																		: 0
																)
															) +
															Number(
																Math.round(
																	baggageChild5?.AirlineCode
																		? baggageChild5?.Price
																		: baggageChild5?.code
																		? baggageChild5?.amount
																		: 0
																)
															) +
															Number(
																Math.round(
																	baggageChild6?.AirlineCode
																		? baggageChild6?.Price
																		: baggageChild6?.code
																		? baggageChild6?.amount
																		: 0
																)
															) +
															Number(
																Math.round(
																	mealAdult1?.AirlineCode
																		? mealAdult1?.Price
																		: mealAdult1?.code
																		? mealAdult1?.amount
																		: 0
																)
															) +
															Number(
																Math.round(
																	mealAdult2?.AirlineCode
																		? mealAdult2?.Price
																		: mealAdult2?.code
																		? mealAdult2?.amount
																		: 0
																)
															) +
															Number(
																Math.round(
																	mealAdult3?.AirlineCode
																		? mealAdult3?.Price
																		: mealAdult3?.code
																		? mealAdult3?.amount
																		: 0
																)
															) +
															Number(
																Math.round(
																	mealAdult4?.AirlineCode
																		? mealAdult4?.Price
																		: mealAdult4?.code
																		? mealAdult4?.amount
																		: 0
																)
															) +
															Number(
																Math.round(
																	mealAdult5?.AirlineCode
																		? mealAdult5?.Price
																		: mealAdult5?.code
																		? mealAdult5?.amount
																		: 0
																)
															) +
															Number(
																Math.round(
																	mealAdult6?.AirlineCode
																		? mealAdult6?.Price
																		: mealAdult6?.code
																		? mealAdult6?.amount
																		: 0
																)
															) +
															Number(
																Math.round(
																	mealAdult7?.AirlineCode
																		? mealAdult7?.Price
																		: mealAdult7?.code
																		? mealAdult7?.amount
																		: 0
																)
															) +
															Number(
																Math.round(
																	mealAdult8?.AirlineCode
																		? mealAdult8?.Price
																		: mealAdult8?.code
																		? mealAdult8?.amount
																		: 0
																)
															) +
															Number(
																Math.round(
																	mealAdult9?.AirlineCode
																		? mealAdult9?.Price
																		: mealAdult9?.code
																		? mealAdult9?.amount
																		: 0
																)
															) +
															Number(
																Math.round(
																	mealChild1?.AirlineCode
																		? mealChild1?.Price
																		: mealChild1?.code
																		? mealChild1?.amount
																		: 0
																)
															) +
															Number(
																Math.round(
																	mealChild2?.AirlineCode
																		? mealChild2?.Price
																		: mealChild2?.code
																		? mealChild2?.amount
																		: 0
																)
															) +
															Number(
																Math.round(
																	mealChild3?.AirlineCode
																		? mealChild3?.Price
																		: mealChild3?.code
																		? mealChild3?.amount
																		: 0
																)
															) +
															Number(
																Math.round(
																	mealChild4?.AirlineCode
																		? mealChild4?.Price
																		: mealChild4?.code
																		? mealChild4?.amount
																		: 0
																)
															) +
															Number(
																Math.round(
																	mealChild5?.AirlineCode
																		? mealChild5?.Price
																		: mealChild5?.code
																		? mealChild5?.amount
																		: 0
																)
															) +
															Number(
																Math.round(
																	mealChild6?.AirlineCode
																		? mealChild6?.Price
																		: mealChild6?.code
																		? mealChild6?.amount
																		: 0
																)
															)
													)
												)
										  )
										: ''
									: location.state.intFlight?.Supplier === 'TBO'
									? Number(
											Math.round(
												Number(
													Number(
														Math.round(
															location.state.intFlight.Fare.Total_Amount
														)
													) -
														Number(
															Math.round(
																location.state.intFlight.Fare.agentMarkup
															)
														) +
														Number(
															Math.round(
																(Number(
																	Number(
																		Math.round(
																			location.state.intFlight.Fare.Total_Amount
																		)
																	) -
																		Number(
																			Math.round(
																				location.state.intFlight.Fare
																					.agentMarkup
																			)
																		)
																) *
																	2.5) /
																	100
															)
														)
												)
											)
									  )
									: Number(
											Math.round(
												Number(
													Number(
														Math.round(
															location.state.selectedonward[0].Airline_Code
																? fareQuoteEtrav
																	? fareQuoteEtrav?.result
																			?.AirRepriceResponses[0].Flight.Fares
																			.Total_Amount
																	: location.state.selectedonward[0].Fares
																			.Total_Amount
																: location.state.selectedonward[0].AirlineCode
																? fareQuote
																	? fareQuote?.result.Response.Results.Fare
																			.Total_Amount
																	: location.state.selectedonward[0].Fare
																			.Total_Amount
																: 0
														)
													) +
														Number(
															Math.round(
																location.state.selectedReturn[0].Airline_Code
																	? fareQuoteEtrav
																		? fareQuoteEtrav?.result
																				?.AirRepriceResponses[1].Flight.Fares
																				.Total_Amount
																		: location.state.selectedReturn[0].Fares
																				.Total_Amount
																	: location.state.selectedReturn[0].AirlineCode
																	? fareQuoteReturn
																		? fareQuoteReturn?.result.Response.Results
																				.Fare.Total_Amount
																		: location.state.selectedReturn[0].Fare
																				.Total_Amount
																	: 0
															) -
																Number(
																	Math.round(
																		location.state.selectedReturn[0]
																			.Airline_Code
																			? 0
																			: location.state.selectedReturn[0]
																					.AirlineCode
																			? fareQuoteReturn
																				? fareQuoteReturn?.result?.Response
																						.Results.Fare.MFB_Discount
																				: location.state.selectedReturn[0].Fare
																						.MFB_Discount
																			: 0
																	)
																) -
																Number(
																	Math.round(
																		location.state.selectedonward[0]
																			.Airline_Code
																			? 0
																			: location.state.selectedonward[0]
																					.AirlineCode
																			? fareQuote
																				? fareQuote?.result.Response.Results
																						.Fare.MFB_Discount
																				: location.state.selectedonward[0].Fare
																						.MFB_Discount
																			: 0
																	)
																)
														) +
														(Number(
															Number(
																Math.round(
																	location.state.selectedonward[0].Airline_Code
																		? fareQuoteEtrav
																			? fareQuoteEtrav?.result
																					?.AirRepriceResponses[0].Flight.Fares
																					.Total_Amount
																			: location.state.selectedonward[0].Fares
																					.Total_Amount
																		: location.state.selectedonward[0]
																				.AirlineCode
																		? fareQuote
																			? fareQuote?.result.Response.Results.Fare
																					.Total_Amount
																			: location.state.selectedonward[0].Fare
																					.Total_Amount
																		: 0
																)
															) +
																Number(
																	Math.round(
																		location.state.selectedReturn[0]
																			.Airline_Code
																			? fareQuoteEtrav
																				? fareQuoteEtrav?.result
																						?.AirRepriceResponses[1].Flight
																						.Fares.Total_Amount
																				: location.state.selectedReturn[0].Fares
																						.Total_Amount
																			: location.state.selectedReturn[0]
																					.AirlineCode
																			? fareQuoteReturn
																				? fareQuoteReturn?.result.Response
																						.Results.Fare.Total_Amount
																				: location.state.selectedReturn[0].Fare
																						.Total_Amount
																			: 0
																	)
																) -
																Number(
																	Math.round(
																		location.state.selectedReturn[0]
																			.Airline_Code
																			? 0
																			: location.state.selectedReturn[0]
																					.AirlineCode
																			? fareQuoteReturn
																				? fareQuoteReturn?.result?.Response
																						.Results.Fare.MFB_Discount
																				: location.state.selectedReturn[0].Fare
																						.MFB_Discount
																			: 0
																	)
																) -
																Number(
																	Math.round(
																		location.state.selectedonward[0]
																			.Airline_Code
																			? 0
																			: location.state.selectedonward[0]
																					.AirlineCode
																			? fareQuote
																				? fareQuote?.result.Response.Results
																						.Fare.MFB_Discount
																				: location.state.selectedonward[0].Fare
																						.MFB_Discount
																			: 0
																	)
																)
														) *
															2.5) /
															100
												)
											)
									  )}
							</span>
							{/* <FormControlLabel
                  style={{ marginRight: 0, marginLeft: 10 }}
                  value="payworldline"
                  control={
                    <Radio
                      checked={payworldline}
                      onClick={handleHold}
                      style={{ marginLeft: 10 }}
                    />
                  }
                  // label='Pay Online'
                />
                <span>Pay With Worline</span>
                <span style={{ marginLeft: 5, color: "blue" }}>
                  {" "}
                  {location.state.OneflightData.Supplier === "TBO"
                    ? Number(
                        Math.round(
                          location.state.OneflightData.Fare.Total_Amount
                        )
                      )-Number(Math.round(location.state.OneflightData.Fare.agentMarkup)) + Number(Math.round(Number(Number(
                        Math.round(
                          location.state.OneflightData.Fare.Total_Amount
                        )
                      )-Number(Math.round(location.state.OneflightData.Fare.agentMarkup)))*2.5/100))
                    : Number(
                        Math.round(
                          location.state.OneflightData.Fares.Total_Amount
                        )
                      )-Number(Math.round(location.state.OneflightData.Fares.agentMarkup)) + Number(Math.round(Number(Number(
                        Math.round(
                          location.state.OneflightData.Fares.Total_Amount
                        )
                      )-Number(Math.round(location.state.OneflightData.Fares.agentMarkup)))*2.5/100))}
                </span> */}
						</Box>
						{/* Submit and Edit Button */}
						<Grid
							container
							spacing={2}
							style={{ marginBottom: 60, marginTop: 20 }}>
							<Grid item xs={4} lg={2}>
								<Button
									className={classes.createButton}
									onClick={edit}
									style={{ marginTop: 10, fontSize: 14 }}
									// disabled={isSubmitting}
								>
									EDIT
								</Button>
							</Grid>
							<Grid item xs={8} lg={4}>
								<Button
									className={classes.createButton}
									onClick={handleFormSubmit}
									style={{ marginTop: 10, fontSize: 14 }}
									disabled={
										payment === 'pay' || payment === 'offline' ? false : true
									}>
									PROCESS TO PAYMENT
								</Button>
							</Grid>
							<Grid item xs={4}></Grid>
						</Grid>
					</Form>
				)}
			</Formik>
			{/* <ErrorModal /> */}
			<WorldlinePG
				handlePayment={handlePayment}
				amountdebit={
					location.state.OneflightData?.AirlineCode
						? Number(
								Math.round(
									fareQuote
										? fareQuote?.result?.Response?.Results.Fare.Total_Amount
										: location.state.OneflightData.Fare.Total_Amount
								)
						  ) -
						  Number(
								Math.round(
									fareQuote
										? fareQuote?.result?.Response?.Results.Fare.MFB_Discount
										: location.state.OneflightData.Fare.MFB_Discount
								)
						  )
						: location.state.OneflightData?.Airline_Code
						? Number(
								Math.round(
									fareQuoteEtrav
										? fareQuoteEtrav?.result?.AirRepriceResponses[0].Flight
												.Fares.Total_Amount
										: location.state.OneflightData.Fares.Total_Amount
								)
						  )
						: etrav2
						? Number(
								Number(
									Math.round(
										fareQuoteEtrav
											? fareQuoteEtrav?.result?.AirRepriceResponses[1].Flight
													.Fares.Total_Amount
											: location.state.selectedReturn[0].Fares.Total_Amount
									)
								) +
									Number(
										Math.round(
											fareQuoteEtrav
												? fareQuoteEtrav?.result?.AirRepriceResponses[0].Flight
														.Fares.Total_Amount
												: location.state.selectedonward[0].Fares.Total_Amount
										)
									)
						  )
						: tbo2
						? Number(
								Number(
									Math.round(
										fareQuoteReturn
											? fareQuoteReturn?.result.Response.Results.Fare
													.Total_Amount
											: location.state.selectedReturn[0].Fare.Total_Amount
									)
								) +
									Number(
										Math.round(
											fareQuote
												? fareQuote?.result.Response.Results.Fare.Total_Amount
												: location.state.selectedonward[0].Fare.Total_Amount
										)
									) -
									Number(
										Math.round(
											fareQuoteReturn
												? fareQuoteReturn?.result?.Response.Results.Fare
														.MFB_Discount
												: location.state.selectedReturn[0].Fare.MFB_Discount
										)
									) -
									Number(
										Math.round(
											fareQuote
												? fareQuote?.result.Response.Results.Fare.MFB_Discount
												: location.state.selectedonward[0].Fare.MFB_Discount
										)
									)
						  )
						: etrvotbor
						? Number(
								Number(
									Math.round(location.state.selectedReturn[0].Fare.Total_Amount)
								) +
									Number(
										Math.round(
											location.state.selectedonward[0].Fares.Total_Amount
										)
									)
						  )
						: etravrtboo
						? Number(
								Number(
									Math.round(
										location.state.selectedReturn[0].Fares.Total_Amount
									)
								) +
									Number(
										Math.round(
											location.state.selectedonward[0].Fare.Total_Amount
										)
									)
						  )
						: location.state.intFlight
						? Number(Math.round(location.state.intFlight.Fare.Total_Amount))
						: ''
				}
			/>
			{/* <BookingAlreadyPNRModal /> */}
		</>
	);
};

export default FlightConfirmForm;
